<template>
  <span>
    <span>
      <b-button class="mr-2"
                variant="success"
                @click="showTaskModal(task)"
                qid="delete-s-cancel-button"
      >

        <span v-if="task">
          {{ $t('tasks.open_button') }}
        </span>
        <span v-if="!task">
          {{ $t('tasks.open_first_task') }}
        </span>
      </b-button>
    </span>

    <!-- Task modal -->
    <b-modal ref="task-modal"
             size="xl"
             @hide="hideTaskModal"
             modal-class="bottom-left task-modal"
    >

      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="minimizeTask" class="btn btn-secondary cursor-pointer float-right">
            <font-awesome-icon icon="window-minimize"/>
          </span>
          <h5 class="mb-1 text-center" v-if="currentView != 'data_collection' && selectedTask && selectedTask.id && selectedTask.model && selectedTask.code != 'system_impact_assessment'">
            {{ $t('tasks.modal.assessment_control_task') }}
            {{ $t('system.for') }}
            {{ selectedTask.full_title }}
          </h5>
          <h5 class="mb-1 text-center" v-if="currentView == 'data_collection' && selectedTask && selectedTask.id && selectedTask.model && selectedTask.code != 'system_impact_assessment'">
            {{ $t('tasks.modal.data_collection_task') }}
            {{ $t('system.for') }}
            {{ selectedTask.full_title }}
          </h5>
          <h5 class="mb-1 text-center" v-if="selectedTask && selectedTask.id && selectedTask.model && selectedTask.scope && selectedTask.code == 'system_impact_assessment'">
            {{ $t('system.assess_how') }}
            <span v-if="selectedTask.model.who_am_i == 'App\\System\\Models\\System'">
              {{ $t('system.the_system') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Activity\\Models\\Activity'">
              {{ $t('system.the_activity') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Process\\Models\\Process'">
              {{ $t('system.the_process') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
              {{ $t('system.the_contract') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'">
              {{ $t('system.the_policy') }}
            </span>
            <span class="breadcrumb-item">
              <a @click="navigateToTask(selectedTask)" :class="{'not-clickable': !isOwner(selectedTask.model)}">
                <font-awesome-icon icon="desktop" class="mr-1" v-if="selectedTask.model.who_am_i == 'App\\System\\Models\\System'"/>
                <font-awesome-icon icon="cubes" class="mr-1" v-if="selectedTask.model.who_am_i == 'App\\Activity\\Models\\Activity'"/>
                <font-awesome-icon icon="cube" class="mr-1" v-if="selectedTask.model.who_am_i == 'App\\Process\\Models\\Process'"/>
                <font-awesome-icon icon="file-signature" class="mr-1" v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'"/>
                <font-awesome-icon icon="file-invoice" class="mr-1" v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'"/>

                {{ selectedTask.model.name }}
              </a>
            </span>

            {{ $t('system.impacts') }}
            <span v-if="selectedTask.scope.who_am_i == 'App\\System\\Models\\System'">
              {{ $t('system.the_system') }}
            </span>
            <span v-if="selectedTask.scope.who_am_i == 'App\\Activity\\Models\\Activity'">
              {{ $t('system.the_activity') }}
            </span>
            <span v-if="selectedTask.scope.who_am_i == 'App\\Process\\Models\\Process'">
              {{ $t('system.the_process') }}
            </span>
            <span v-if="selectedTask.scope.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
              {{ $t('system.the_contract') }}
            </span>
            <span v-if="selectedTask.scope.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'">
              {{ $t('system.the_policy') }}
            </span>
            <span class="breadcrumb-item" v-if="selectedTask.scope">
              <a @click="navigateToTaskScope(selectedTask)" :class="{'not-clickable': !isOwner(selectedTask.scope)}">
                <font-awesome-icon icon="desktop" class="mr-1" v-if="selectedTask.scope.who_am_i == 'App\\System\\Models\\System'"/>
                <font-awesome-icon icon="cubes" class="mr-1" v-if="selectedTask.scope.who_am_i == 'App\\Activity\\Models\\Activity'"/>
                <font-awesome-icon icon="cube" class="mr-1" v-if="selectedTask.scope.who_am_i == 'App\\Process\\Models\\Process'"/>
                <font-awesome-icon icon="file-signature" class="mr-1" v-if="selectedTask.scope.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'"/>
                <font-awesome-icon icon="file-invoice" class="mr-1" v-if="selectedTask.scope.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'"/>

                {{ selectedTask.scope.name }}
              </a>
            </span>
          </h5>
          <div class="row mt-3 pt-4 pb-1" v-if="selectedTask && selectedTask.id">
            <div class="col-sm-6"
                 v-if="selectedTask.scope && selectedTask.scope.name"
            >
              <b-form-group>
                <div class="" v-if="selectedTask.project">
                  <div v-if="isOwner(selectedTask) && currentView == 'data_collection'">
                    <span class="text-success breadcrumb-item cursor-pointer" @click="switchCurrentView('default')">
                      <font-awesome-icon icon="angle-left" class="mr-1"/>
                      {{ $t('tasks.modal.back_to_main_task') }}
                    </span>
                  </div>

                  <label qid="task-name" v-if="selectedTask.code == 'system_impact_assessment'">
                    {{ $t('tasks.modal.system_impact_title') }}
                  </label>
                  <div v-if="selectedTask.code == 'system_impact_assessment'" class="text-formatted">
                    <span v-if="selectedTask.scope.who_am_i == 'App\\Process\\Models\\Process'">
                      {{ $t('tasks.modal.system_impact_description_process') }}
                    </span>
                    <span v-if="selectedTask.scope.who_am_i == 'App\\Activity\\Models\\Activity'">
                      {{ $t('tasks.modal.system_impact_description_activity') }}
                    </span>
                  </div>
                  <div v-if="selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'">
                    <div v-if="selectedTask.description && selectedTask.description.length > 300">
                      <p v-if="showFullTaskDescription" class="text-formatted">
                        {{ selectedTask.description }}
                      </p>
                      <p v-if="!showFullTaskDescription" class="text-formatted">
                        {{ selectedTask.description | truncate(300) }}
                      </p>
                      <div class="text-center mt-3" @click="showFullTaskDescription=!showFullTaskDescription">
                        <span class="cursor-pointer" v-if="!showFullTaskDescription">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down"/>
                        </span>
                        <span class="cursor-pointer" v-if="showFullTaskDescription">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up"/>
                        </span>
                      </div>
                    </div>
                    <p v-if="selectedTask.description && selectedTask.description.length <= 300"
                       class="text-formatted"
                    >
                      {{ selectedTask.description }}
                    </p>
                  </div>
                  <div v-if="selectedTask.code != 'system_impact_assessment' && currentView == 'data_collection'">
                    <div v-if="selectedTask.data_collection_description && selectedTask.data_collection_description.length > 300">
                      <p v-if="showFullTaskDescription" class="text-formatted">
                        {{ selectedTask.data_collection_description }}
                      </p>
                      <p v-if="!showFullTaskDescription" class="text-formatted">
                        {{ selectedTask.data_collection_description | truncate(300) }}
                      </p>
                      <div class="text-center mt-3" @click="showFullTaskDescription=!showFullTaskDescription">
                        <span class="cursor-pointer" v-if="!showFullTaskDescription">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down"/>
                        </span>
                        <span class="cursor-pointer" v-if="showFullTaskDescription">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up"/>
                        </span>
                      </div>
                    </div>
                    <p v-if="selectedTask.data_collection_description && selectedTask.data_collection_description.length <= 300"
                       class="text-formatted"
                    >
                      {{ selectedTask.data_collection_description }}
                    </p>
                  </div>
                </div>
                <div class="mt-2 mb-1" v-if="getMedia('question') && currentView != 'data_collection'">
                  <p v-for="(file, index) in getMedia('question')" :key="index">
                    <span class="mr-3 float-right text-muted cursor-pointer"
                          @click="downloadMedia(file)"
                          qid="download-media"
                    >
                      <font-awesome-icon icon="cloud-download-alt" />
                    </span>
                    <a @click="downloadMedia(file)" qid="create-p-media-item">
                      {{ file.file_name }}
                    </a>
                  </p>
                </div>
                <div class="mt-2 mb-1" v-if="getMedia('data_collection') && currentView == 'data_collection'">
                  <p v-for="(file, index) in getMedia('data_collection')" :key="index">
                    <span class="mr-3 float-right text-muted cursor-pointer"
                          @click="downloadMedia(file)"
                          qid="download-media"
                    >
                      <font-awesome-icon icon="cloud-download-alt" />
                    </span>
                    <a @click="downloadMedia(file)" qid="create-p-media-item">
                      {{ file.file_name }}
                    </a>
                  </p>
                </div>

                <div class="" v-if="getLinks('question') && currentView != 'data_collection'">
                  <p v-for="(link, index) in getLinks('question')" :key="index">
                    <a :href="link.url" target="_blank" qid="create-p-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
                <div class="" v-if="getLinks('data_collection') && currentView == 'data_collection'">
                  <p v-for="(link, index) in getLinks('data_collection')" :key="index">
                    <a :href="link.url" target="_blank" qid="create-p-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
              </b-form-group>

            </div>
            <div :class="{'col-sm-6': selectedTask.scope && selectedTask.scope.name, 'col-sm-12': !selectedTask.scope.name}">
              <b-form-group>
                <div class="" v-if="selectedTask.project">
                  <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openWelcomePage()" v-if="welcomeGuide && welcomeGuide.id">
                    <font-awesome-icon icon="eye" />
                    {{ $t('system.welcome_page_button') }}
                  </span>
                  <div v-if="selectedTask.code != 'system_impact_assessment' && selectedTask.project.project_type == 'type two' && currentView != 'data_collection'">
                    <div v-if="selectedTask.description_two && selectedTask.description_two.length > 300">
                      <p v-if="showFullDataCollectionTwoDescription" class="text-formatted">
                        {{ selectedTask.description_two }}
                      </p>
                      <p v-if="!showFullDataCollectionTwoDescription" class="text-formatted">
                        {{ selectedTask.description_two | truncate(300) }}
                      </p>
                      <div class="text-center mt-3"
                           @click="showFullDataCollectionTwoDescription=!showFullDataCollectionTwoDescription">
                        <span class="cursor-pointer" v-if="!showFullDataCollectionTwoDescription">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down"/>
                        </span>
                        <span class="cursor-pointer" v-if="showFullDataCollectionTwoDescription">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up"/>
                        </span>
                      </div>
                    </div>
                    <p v-if="selectedTask.description_two && selectedTask.description_two.length <= 300"
                       class="text-formatted"
                    >
                      {{ selectedTask.description_two }}
                    </p>
                  </div>
                  <div v-if="selectedTask.code != 'system_impact_assessment' && selectedTask.project.project_type == 'type two' && currentView == 'data_collection'">
                    <div :style="{ marginTop: isOwner(selectedTask) ? '15px' : '0' }" v-if="selectedTask.data_collection_description_two && selectedTask.data_collection_description_two.length > 300">
                      <p v-if="showFullDataCollectionTwoDescription" class="text-formatted">
                        {{ selectedTask.data_collection_description_two }}
                      </p>
                      <p v-if="!showFullDataCollectionTwoDescription" class="text-formatted">
                        {{ selectedTask.data_collection_description_two | truncate(300) }}
                      </p>
                      <div class="text-center mt-3"
                           @click="showFullDataCollectionTwoDescription=!showFullDataCollectionTwoDescription">
                        <span class="cursor-pointer" v-if="!showFullDataCollectionTwoDescription">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down"/>
                        </span>
                        <span class="cursor-pointer" v-if="showFullDataCollectionTwoDescription">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up"/>
                        </span>
                      </div>
                    </div>
                    <p  :style="{ marginTop: isOwner(selectedTask) ? '15px' : '0' }" v-if="selectedTask.data_collection_description_two && selectedTask.data_collection_description_two.length <= 300"
                        class="text-formatted"
                    >
                      {{ selectedTask.data_collection_description_two }}
                    </p>
                  </div>
                  <div v-if="getGuide('assessment_task') && currentView == 'default' && selectedTask.code != 'update_measures'" style="margin-top:20px;">
                    <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openGuide()">
                      <font-awesome-icon icon="eye" />
                      {{ $t('administration.guide.modal.button') }}
                    </span>

                    <label qid="create-p-users-label" v-if="selectedTask.project && selectedTask.project.schedule_message">
                      {{ $t('tasks.modal.project_message_label') }}
                    </label>
                    <div class="" v-if="selectedTask.project && selectedTask.project.schedule_message">
                      <p>
                        {{ selectedTask.project.schedule_message }}
                      </p>
                    </div>

                    <label qid="create-p-users-label">
                      {{ $t('system.help_center_label') }}
                    </label>
                    <div v-if="wpGuide && wpGuide.id" class="guide-content-container">
                      <p v-if="!showFullGuideDescription" v-html="wpGuide.excerpt.rendered"></p>
                      <p v-if="showFullGuideDescription" v-html="wpGuide.content.rendered"></p>

                      <div class="text-center mt-3" @click="showFullGuideDescription=!showFullGuideDescription">
                        <span class="cursor-pointer" v-if="!showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down"/>
                        </span>
                        <span class="cursor-pointer" v-if="showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up"/>
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Data collection guide -->
                  <div v-if="getGuide('data_collection_task') && currentView == 'data_collection'" style="margin-top:20px;">
                    <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openGuide()">
                      <font-awesome-icon icon="eye" />
                      {{ $t('administration.guide.modal.button') }}
                    </span>

                    <label qid="create-p-users-label" v-if="selectedTask.project && selectedTask.project.schedule_message">
                      {{ $t('tasks.modal.project_message_label') }}
                    </label>
                    <div class="" v-if="selectedTask.project && selectedTask.project.schedule_message">
                      <p>
                        {{ selectedTask.project.schedule_message }}
                      </p>
                    </div>

                    <label qid="create-p-users-label">
                      {{ $t('system.help_center_label') }}
                    </label>
                    <div v-if="wpGuideData && wpGuideData.id" class="guide-content-container">
                      <p v-if="!showFullGuideDescription" v-html="wpGuideData.excerpt.rendered"></p>
                      <p v-if="showFullGuideDescription" v-html="wpGuideData.content.rendered"></p>

                      <div class="text-center mt-3" @click="showFullGuideDescription=!showFullGuideDescription">
                        <span class="cursor-pointer" v-if="!showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down"/>
                        </span>
                        <span class="cursor-pointer" v-if="showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up"/>
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- System description guide -->
                  <div v-if="getGuide('system_description_task') && currentView == 'default' && selectedTask.code == 'update_measures'" style="margin-top:20px;">
                    <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openGuide()">
                      <font-awesome-icon icon="eye" />
                      {{ $t('administration.guide.modal.button') }}
                    </span>

                    <label qid="create-p-users-label" v-if="selectedTask.project && selectedTask.project.schedule_message">
                      {{ $t('tasks.modal.project_message_label') }}
                    </label>
                    <div class="" v-if="selectedTask.project && selectedTask.project.schedule_message">
                      <p>
                        {{ selectedTask.project.schedule_message }}
                      </p>
                    </div>

                    <label qid="create-p-users-label">
                      {{ $t('system.help_center_label') }}
                    </label>
                    <div v-if="wpGuideSystem && wpGuideSystem.id" class="guide-content-container">
                      <p v-if="!showFullGuideDescription" v-html="wpGuideSystem.excerpt.rendered"></p>
                      <p v-if="showFullGuideDescription" v-html="wpGuideSystem.content.rendered"></p>

                      <div class="text-center mt-3" @click="showFullGuideDescription=!showFullGuideDescription">
                        <span class="cursor-pointer" v-if="!showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down"/>
                        </span>
                        <span class="cursor-pointer" v-if="showFullGuideDescription">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up"/>
                        </span>
                      </div>
                    </div>
                  </div>

                </div>
                <div v-if="selectedTask.project">
                  <div class="mt-2 mb-1" v-if="getReportMedia && getReportMedia.length">
                    <p v-for="(file, index) in getReportMedia" :key="index">
                      <span class="mr-3 float-right text-muted cursor-pointer"
                            @click="downloadMedia(file)"
                            qid="download-media"
                      >
                        <font-awesome-icon icon="cloud-download-alt" />
                      </span>
                      <a @click="downloadMedia(file)" qid="create-p-media-item">
                        {{ file.file_name }}
                      </a>
                    </p>
                  </div>
                </div>
                <div v-if="selectedTask.project">
                  <div class="" v-if="getReportLinks && getReportLinks.length">
                    <p v-for="(link, index) in getReportLinks" :key="index">
                      <a :href="link.url" target="_blank" qid="create-p-link-item">
                        {{ link.name ? link.name : link.url }}
                      </a>
                    </p>
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-p-error"
      >
        {{ error }}
      </b-alert>

      <b-form qid="create-p-form" v-if="selectedTask && selectedTask.model && currentView == 'default' && selectedTask.code != 'update_measures'">
        <div class="form-container mt-0 mb-2">
          <div class="row mt-1">
            <div class="col-sm-6" v-if="selectedTask.code != 'system_impact_assessment'">

              <!--Assessment tasks-->
              <div v-if="selectedTask && selectedTask.add_response && selectedTask.add_response != 'Optional' && selectedTask.add_response != 'Mandatory' && selectedTask.add_notes == 'Optional' && selectedTask.add_notes == 'Mandatory'">
                <h5>
                  {{ $t('tasks.modal.assessment_task_title') }}
                </h5>
                <hr>
              </div>

              <b-form-group v-if="selectedTask && selectedTask.add_response && selectedTask.add_response == 'Optional' || selectedTask.add_response == 'Mandatory'">
                <label qid="assessment-form-response-label" style="font-size: medium;" class="mt-3">
                  {{ $t('tasks.modal.response_label') }}
                  <span class="text-red" v-if="selectedTask && selectedTask.add_response == 'Mandatory'">*</span>
                </label>

                <span class="btn btn-edit float-right"
                      @click="editModeResponse = !editModeResponse"
                      v-if="!editModeResponse && ((selectedTask.response_type != 'Datepicker' && selectedAnswer) || (selectedTask.response_type == 'Datepicker' && selectedDate))"
                >
                  <font-awesome-icon icon="pen"/>
                </span>

                <div v-if="selectedTask.response_type != 'Datepicker'">
                  <multiselect
                    v-if="editModeResponse"
                    v-model="selectedAnswer"
                    qid="assessment-form-response-drop-down"
                    :options="allAnswers"
                    :multiple="false"
                    :taggable="false"
                    label="title"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('tasks.modal.response_placeholder')"
                  ></multiselect>

                  <p v-if="!editModeResponse && selectedAnswer && selectedAnswer.title" class="">
                    <font-awesome-icon icon="check-circle" class="icon-success" v-if="getIcon(selectedTask) == 'Positive'"/>
                    <font-awesome-icon icon="times-circle" class="icon-danger" v-if="getIcon(selectedTask) == 'Negative'"/>
                    <font-awesome-icon icon="info-circle" class="icon-info" v-if="getIcon(selectedTask) == 'Neutral'"/>
                    <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'" v-if="getIcon(selectedTask) == 'Very low'"/>
                    <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'" v-if="getIcon(selectedTask) == 'Low'"/>
                    <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'" v-if="getIcon(selectedTask) == 'High'"/>
                    <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'" v-if="getIcon(selectedTask) == 'Very high'"/>
                    {{ selectedAnswer.title }}
                  </p>
                </div>

                <div v-if="selectedTask.response_type == 'Datepicker'">
                  <datepicker
                    v-if="editModeResponse"
                    class="date-picker"
                    qid="assessment-form-response-datepicker"
                    calendar-class="right"
                    v-model="selectedDate"
                    :clear-button="true"
                    :placeholder="$t('tasks.modal.response_label')"
                  ></datepicker>

                  <p v-if="!editModeResponse && selectedDate" class="">
                    <font-awesome-icon icon="calendar-alt" class="mr-1"/>
                    {{ selectedDate | formatDate }}
                  </p>
                </div>
              </b-form-group>


              <!--Notes-->
              <b-form-group v-if="selectedTask && selectedTask.add_notes && selectedTask.add_notes == 'Optional' || selectedTask.add_notes == 'Mandatory'" class="mb-3">
                <label qid="assessment-form-notes-label" style="font-size: medium;" class="mt-3">
                  {{ $t('tasks.modal.notes_label') }}
                  <span class="text-red" v-if="selectedTask && selectedTask.add_notes == 'Mandatory'">*</span>
                </label>

                <span
                    class="btn btn-edit float-right"
                    @click="editModeNotes = !editModeNotes"
                    v-if="!editModeNotes && taskForm.notes">
                  <font-awesome-icon icon="pen"/>
                </span>

                <div v-if="(!taskForm || !taskForm.notes) && !editModeNotes">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </div>

                <b-form-textarea
                  qid="assessment-form-notes"
                  v-model="taskForm.notes"
                  v-if="editModeNotes"
                  rows="6"
                  max-rows="6"
                  :required="selectedTask.add_notes == 'Mandatory'"
                  :placeholder="$t('tasks.modal.notes_placeholder')"
                ></b-form-textarea>

                <div v-if="!editModeNotes" style="margin-top: -20px;">
                  <div v-if="taskForm.notes && taskForm.notes.length > 300">
                    <p v-if="showFullTextNotes" class="text-formatted">
                      {{ taskForm.notes }}
                    </p>

                    <p v-if="!showFullTextNotes" class="text-formatted">
                      {{ taskForm.notes | truncate(300) }}
                    </p>

                    <div class="text-center mt-3" @click="showFullTextNotes=!showFullTextNotes">
                      <span class="cursor-pointer" v-if="!showFullTextNotes">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullTextNotes">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>

                  <p v-if="taskForm.notes && taskForm.notes.length <= 300"
                     class="text-formatted"
                  >
                    {{ taskForm.notes }}
                  </p>
                </div>
              </b-form-group>

              <!--Audit reporting-->
              <h5>
                {{ $t('tasks.modal.audit_reporting_title') }}
              </h5>

              <hr>

              <!--Control Description-->
              <b-form-group v-if="selectedTask && selectedTask.add_control_description && selectedTask.add_control_description == 'Optional' || selectedTask.add_control_description == 'Mandatory'">
                <label qid="assessment-form-control-description-label" style="font-size: medium;" class="mt-3">
                  {{ $t('tasks.modal.control_description_label') }}
                  <span class="text-red" v-if="selectedTask && selectedTask.add_control_description == 'Mandatory'">*</span>
                </label>

                <span v-if="editModeControlDescription"
                      class="float-right text-success cursor-pointer pt-3"
                      @click="taskForm.control_description = selectedTask.data_remarks"
                >
                  {{ $t('tasks.modal.copy_data_collection_text_label') }}
                </span>

                <span
                    class="btn btn-edit float-right"
                    @click="editModeControlDescription = !editModeControlDescription"
                    v-if="!editModeControlDescription && taskForm.control_description">
                  <font-awesome-icon icon="pen"/>
                </span>

                <div v-if="(!taskForm || !taskForm.control_description) && !editModeControlDescription">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </div>

                <b-form-textarea
                  qid="assessment-form-control-description"
                  v-model="taskForm.control_description"
                  v-if="editModeControlDescription"
                  rows="6"
                  max-rows="6"
                  :required="selectedTask.add_control_description == 'Mandatory'"
                  :placeholder="$t('tasks.modal.control_description_placeholder')"
                ></b-form-textarea>

                <div v-if="!editModeControlDescription" style="margin-top: -20px;">
                  <div v-if="taskForm.control_description && taskForm.control_description.length > 300">
                    <p v-if="showFullTextControlDescription" class="text-formatted">
                      {{ taskForm.control_description }}
                    </p>

                    <p v-if="!showFullTextControlDescription" class="text-formatted">
                      {{ taskForm.control_description | truncate(300) }}
                    </p>

                    <div class="text-center mt-3" @click="showFullTextControlDescription=!showFullTextControlDescription">
                      <span class="cursor-pointer" v-if="!showFullTextControlDescription">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullTextControlDescription">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>

                  <p v-if="taskForm.control_description && taskForm.control_description.length <= 300"
                     class="text-formatted"
                  >
                    {{ taskForm.control_description }}
                  </p>
                </div>
              </b-form-group>


              <!--Performed test-->
              <b-form-group v-if="selectedTask && selectedTask.add_performed_text && selectedTask.add_performed_text == 'Optional' || selectedTask.add_performed_text == 'Mandatory'">
                <label qid="assessment-form-performed-test-label" style="font-size: medium;" class="mt-3">
                  {{ $t('tasks.modal.performed_test_label') }}
                  <span class="text-red" v-if="selectedTask && selectedTask.add_performed_text == 'Mandatory'">*</span>
                </label>

                <span
                    class="btn btn-edit float-right"
                    @click="editModePerformedTest = !editModePerformedTest"
                    v-if="!editModePerformedTest && taskForm.performed_text">
                  <font-awesome-icon icon="pen"/>
                </span>

                <div v-if="(!taskForm || !taskForm.performed_text) && !editModePerformedTest">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </div>

                <b-form-textarea
                  qid="assessment-form-performed-test"
                  v-model="taskForm.performed_text"
                  v-if="editModePerformedTest"
                  rows="6"
                  max-rows="6"
                  :required="selectedTask.add_performed_text == 'Mandatory'"
                  :placeholder="$t('tasks.modal.performed_test_placeholder')"
                ></b-form-textarea>

                <div v-if="!editModePerformedTest" style="margin-top: -20px;">
                  <div v-if="taskForm.performed_text && taskForm.performed_text.length > 300">
                    <p v-if="showFullTextPerformedTest" class="text-formatted">
                      {{ taskForm.performed_text }}
                    </p>

                    <p v-if="!showFullTextPerformedTest" class="text-formatted">
                      {{ taskForm.performed_text | truncate(300) }}
                    </p>

                    <div class="text-center mt-3" @click="showFullTextPerformedTest=!showFullTextPerformedTest">
                      <span class="cursor-pointer" v-if="!showFullTextPerformedTest">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullTextPerformedTest">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>

                  <p v-if="taskForm.performed_text && taskForm.performed_text.length <= 300"
                     class="text-formatted"
                  >
                    {{ taskForm.performed_text }}
                  </p>
                </div>
              </b-form-group>


              <!--Conclusion-->
              <b-form-group v-if="selectedTask && selectedTask.add_description && selectedTask.add_description == 'Optional' || selectedTask.add_description == 'Mandatory'">
                <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                  {{ $t('tasks.modal.remarks_label') }}
                  <span class="text-red" v-if="selectedTask && selectedTask.add_description == 'Mandatory'">*</span>
                </label>

                <span
                    class="btn btn-edit float-right"
                    @click="editModeConclusion = !editModeConclusion"
                    v-if="!editModeConclusion && taskForm.remarks">
                  <font-awesome-icon icon="pen"/>
                </span>

                <div v-if="(!taskForm || !taskForm.remarks) && !editModeConclusion">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </div>

                <b-form-textarea
                    qid="assessment-form-conclusion"
                    v-model="taskForm.remarks"
                    v-if="editModeConclusion"
                    rows="6"
                    max-rows="6"
                    :placeholder="$t('tasks.modal.remarks_placeholder')"
                ></b-form-textarea>

                <div v-if="!editModeConclusion" style="margin-top: -20px;">
                  <div v-if="taskForm.remarks && taskForm.remarks.length > 300">
                    <p v-if="showFullTextConclusion" class="text-formatted">
                      {{ taskForm.remarks }}
                    </p>

                    <p v-if="!showFullTextConclusion" class="text-formatted">
                      {{ taskForm.remarks | truncate(300) }}
                    </p>

                    <div class="text-center mt-3" @click="showFullTextConclusion=!showFullTextConclusion">
                      <span class="cursor-pointer" v-if="!showFullTextConclusion">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullTextConclusion">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>

                  <p v-if="taskForm.remarks && taskForm.remarks.length <= 300"
                     class="text-formatted"
                  >
                    {{ taskForm.remarks }}
                  </p>
                </div>
              </b-form-group>
              <div class="w-100" @dragover.prevent @drop.prevent="handleDrop">
                <div v-show="showDropActive" class="drop-active">
                  <h3>Drop files to upload</h3>
                </div>
                 <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                  {{ $t('attachments.label') }}
                </label>
                <span class="float-right">
                    <file-upload
                            v-if="selectedTask.status != 'completed'"
                            ref="uploader"
                            v-model="files"
                            :drop="true"
                            :multiple="true"
                            input-id="task-file"
                            @input="onFileChangeEdit"
                            @dropActive="showDropActiveFunction"
                            @dropInactive="hideDropActiveFunction"
                            class="text-success cursor-pointer float:right"
                    >
                        {{ $t('tasks.modal.add_attachment_label') }}
                      </file-upload>
                </span>
              </div>
              <ul class="list-secondary" style="list-style-type: none; padding-left: 0;">
                <li v-for="(item, index) in getMedia('task')" :key="index" class="text-bold list-item mb-2">
                  <span>
                    <a :href="item.url" target="_blank" class="btn" qid="download-media">
                      {{ item.full_title }}
                    </a>
                  </span>
                  <span class="actions" style="float: right;">
                    <a :href="item.url" target="_blank" class="btn" qid="download-media">
                      <font-awesome-icon icon="eye"/>
                    </a>
                    <span class="btn" @click="downloadMedia(item)" qid="download-media">
                      <font-awesome-icon icon="cloud-download-alt"/>
                    </span>
                    <span class="btn" @click="openDeleteAttachmentModal(item)" qid="remove-media-item" v-if="selectedTask.status != 'completed'">
                      <font-awesome-icon icon="trash-alt"/>
                    </span>
                  </span>
                </li>
                <li v-if="!getMedia('task').length" qid="no-results-row-rr" class="text-center">
                  <h5 class="mt-3">{{ $t('system.no_results') }}</h5>
                </li>
              </ul>
            </div>
            <div class="col-sm-6" v-if="selectedTask.code != 'system_impact_assessment'">
              <div v-if="selectedTask.data_collection_on">
                <h5 v-if="selectedTask.project">
                  <span class="btn btn-secondary btn-sm float-right"
                        v-if="isDataOwner(selectedTask)"
                        @click="switchCurrentView('data_collection')"
                  >
                    {{ $t('tasks.modal.open_data_collection') }}
                  </span>
                  {{ $t('tasks.modal.data_collection_title') }}
                </h5>

                <hr>

                <div>
                  <div class="mt-3 mb-3">
                    <span v-if="selectedTask.data_status && selectedTask.data_status === 'completed'" >
                      <font-awesome-icon icon="check-circle" class="icon-success"/>
                    </span>
                    <span v-if="selectedTask.data_status && selectedTask.data_status === 'pending'" class="pr-1">
                      <font-awesome-icon
                          icon="exclamation-triangle"
                          class="risk-6"
                      />
                    </span>
                    <span v-if="selectedTask.data_status">
                      {{ $t('system.' + $options.filters.slugify(selectedTask.data_status)) }}
                    </span>
                    <span v-if="!selectedTask.data_status">
                      <font-awesome-icon
                          icon="exclamation-triangle"
                          class="risk-6"
                      />
                      {{ $t('system.pending') }}
                    </span>
                  </div>

                  <label qid="assessment-form-documentation-collection-control-description-label" style="font-size: medium;" class="mt-3">
                    {{ $t('tasks.modal.control_description_label') }}
                  </label>
                  <div style="margin-top: -20px;" v-if="selectedTask.data_remarks && selectedTask.data_remarks.length">
                    <div v-if="selectedTask.data_remarks && selectedTask.data_remarks.length > 300">
                      <p v-if="showFullDataCollectionDescription" class="text-formatted">
                        {{ selectedTask.data_remarks }}
                      </p>
                      <p v-if="!showFullDataCollectionDescription" class="text-formatted">
                        {{ selectedTask.data_remarks | truncate(300) }}
                      </p>
                      <div class="text-center mt-3" @click="showFullDataCollectionDescription=!showFullDataCollectionDescription">
                        <span class="cursor-pointer" v-if="!showFullDataCollectionDescription">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down"/>
                        </span>
                        <span class="cursor-pointer" v-if="showFullDataCollectionDescription">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up"/>
                        </span>
                      </div>
                    </div>

                    <p v-if="selectedTask.data_remarks && selectedTask.data_remarks.length <= 300"
                       class="text-formatted"
                    >
                      {{ selectedTask.data_remarks }}
                    </p>
                  </div>
                  <div v-else class="text-muted">
                    {{ $t('system.no_results') }}
                  </div>
                </div>

                <h5 class="mt-4">
                  <span class="btn btn-secondary btn-sm float-right"
                        @click="reopenFormSubmit"
                        v-if="selectedTask.data_status && selectedTask.data_status === 'completed'"
                  >
                    {{ $t('tasks.modal.data_collection_reopen_button') }}
                  </span>
                  {{ $t('tasks.modal.data_collection_chat_title') }}
                </h5>

                <hr>

                <div class="mt-3 mb-3">
                  <div class="row" v-if="selectedTask.data_status != 'completed'">
                    <div class="col-sm-10 chat-box-col-text">
                      <b-form-textarea
                        qid="create-s-form-description"
                        v-model="comment"
                        class="chat-box-text"
                        rows="2"
                        max-rows="2"
                        :placeholder="$t('tasks.modal.question_to_recipient_label')"
                      ></b-form-textarea>
                    </div>
                    <div class="col-sm-2 chat-box-col-button cursor-pointer">
                      <div class="chat-box-button" @click="addCommentSubmit">
                        {{ $t('tasks.modal.send_button_label') }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-3 mb-3">
                  <div class="row">
                    <div class="col-sm-12">
                      <span class="text-bold">
                        {{ $t('tasks.table.data_collection_assignee') }}:
                      </span>
                      <span v-if="selectedTask.data_users && selectedTask.data_users.length">
                        <span class="mr-1 text-normal"
                              v-for="(user, index) in selectedTask.data_users"
                              :key="index"
                        >
                          <span qid="profile-photo">
                            <Avatar :object="user" size="xs"></Avatar>
                          </span>
                        </span>
                      </span>
                      <span v-if="!selectedTask.data_users.length" class="mr-1">
                        <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-1"/>
                        {{ $t('risk.missing_input')}}
                      </span>
                      <span class="pl-2 cursor-pointer" @click="showReopenDataCollectionModal">
                        <font-awesome-icon icon="pen"/>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="form-control scrollable-height-260 pt-3" style="background-color: white;">
                  <div v-if="previousComments && previousComments.length">
                    <div v-for="(comment, index) in previousComments"
                         class="mt-2 chat-message"
                         :key="index"
                    >
                      <p>
                        <span class="cursor-pointer float-right"
                              @click="openDeleteCommentModal(comment)"
                              v-if="isCommentOwner(comment)"
                              qid="view-p-remove-link"
                        >
                          <font-awesome-icon icon="trash-alt" />
                        </span>
                        <Avatar :object="comment.user" size="xs"></Avatar>
                        <span class="ml-1">
                          {{ comment.user.name }}
                        </span>
                        {{$t('system.on')}}
                        <span class="text-normal">
                          {{ comment.updated_at | formatDateTime }}
                        </span>
                      </p>
                      <div v-if="comment.comment && comment.comment.length > 300">
                        <p v-if="comment.expanded" class="text-formatted">{{ comment.comment }}</p>

                        <p v-if="!comment.expanded" class="text-formatted">{{ comment.comment | truncate(300) }}</p>

                        <div class="text-center mt-3" @click="comment.expanded=!comment.expanded">
                          <span class="cursor-pointer" v-if="!comment.expanded">
                            <span class="mr-2">
                              {{ $t('system.view_more') }}
                            </span>
                            <font-awesome-icon icon="chevron-down"/>
                          </span>
                          <span class="cursor-pointer" v-if="comment.expanded">
                            <span class="mr-2">
                              {{ $t('system.view_less') }}
                            </span>
                            <font-awesome-icon icon="chevron-up"/>
                          </span>
                        </div>
                      </div>

                      <p v-if="comment.comment && comment.comment.length <= 300" class="text-formatted">{{ comment.comment }}</p>
                    </div>
                  </div>
                  <div v-if="!previousComments.length" class="text-center">
                    <h5 class="mt-3">
                      {{ $t('system.no_results') }}
                    </h5>
                  </div>
                </div>

              </div>
            </div>

            <!-- System risk task form -->
            <div class="col-sm-6" v-if="selectedTask.code == 'system_impact_assessment'">
              <b-form-group>
                <label qid="create-s-tags-label">
                  {{ $t('processes.confidentiality.title') }}
                  <span class="text-red">*</span>
                </label>
                <multiselect
                    v-model="selectedConfidentialityImpact"
                    :options="impactItems"
                    :placeholder="$t('processes.risk.impact_placeholder')"
                    label="name"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="confidentiality-form-impact"
                ></multiselect>
              </b-form-group>
              <b-form-group>
                <label qid="create-s-tags-label">
                  {{ $t('processes.integrity.title') }}
                  <span class="text-red">*</span>
                </label>
                <multiselect
                    v-model="selectedIntegrityImpact"
                    :options="impactItems"
                    :placeholder="$t('processes.risk.impact_placeholder')"
                    label="name"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="confidentiality-form-impact"
                ></multiselect>
              </b-form-group>
              <b-form-group>
                <label qid="create-s-tags-label">
                  {{ $t('processes.availability.title') }}
                  <span class="text-red">*</span>
                </label>
                <multiselect
                    v-model="selectedAvailabilityImpact"
                    :options="impactItems"
                    :placeholder="$t('processes.risk.impact_placeholder')"
                    label="name"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="confidentiality-form-impact"
                ></multiselect>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-users-label">
                  {{ $t('tasks.modal.rto_label') }}
                  <span class="text-red">*</span>
                </label>
                <div class="row">
                  <div class="col-sm-6">
                    <b-form-input
                      qid="create-s-form-name"
                      type="number"
                      min="0"
                      :placeholder="$t('projects.schedule.every_placeholder')"
                      v-model="taskForm.rto"
                    ></b-form-input>
                  </div>
                  <div class="col-sm-6">
                    <multiselect
                        v-model="rtoInterval"
                        :options="intervalOptions"
                        :placeholder="$t('projects.schedule.interval_placeholder')"
                        label="text"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="create-p-form-pg"
                    ></multiselect>
                  </div>
                </div>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-users-label">
                  {{ $t('tasks.modal.rpo_label') }}
                  <span class="text-red">*</span>
                </label>
                <div class="row">
                  <div class="col-sm-6">
                    <b-form-input
                      qid="create-s-form-name"
                      type="number"
                      min="0"
                      :placeholder="$t('projects.schedule.every_placeholder')"
                      v-model="taskForm.rpo"
                    ></b-form-input>
                  </div>
                  <div class="col-sm-6">
                    <multiselect
                        v-model="rpoInterval"
                        :options="intervalOptions"
                        :placeholder="$t('projects.schedule.interval_placeholder')"
                        label="text"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="create-p-form-pg"
                    ></multiselect>
                  </div>
                </div>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-users-label">
                  {{ $t('tasks.modal.remarks_label') }}
                  <span class="text-red">*</span>
                </label>
                <b-form-textarea
                    qid="create-s-form-description"
                    v-model="taskForm.remarks"
                    rows="6"
                    max-rows="6"
                    :required="selectedTask.add_description == 'Mandatory'"
                    :placeholder="$t('tasks.modal.remarks_placeholder')"
                ></b-form-textarea>
              </b-form-group>
            </div>

          </div>
        </div>

      </b-form>


      <!-- Documentation collection view -->
      <b-form qid="create-p-form" v-if="selectedTask && selectedTask.model && currentView == 'data_collection' && selectedTask.code != 'update_measures'">
        <div class="form-container mt-0 mb-2">
          <div class="row mt-1">
            <div class="col-sm-6" v-if="selectedTask.code != 'system_impact_assessment'">
              <h5>
                {{ $t('tasks.modal.data_collection_task_title') }}
              </h5>
              <hr>
              <br>

              <b-form-group v-if="selectedTask && selectedTask.data_collection_add_description && selectedTask.data_collection_add_description == 'Optional' || selectedTask.data_collection_add_description == 'Mandatory'">
                <label qid="assessment-form-documentation-collection-control-description-label" style="font-size: medium;" class="mt-3">
                  {{ $t('tasks.modal.control_description_label') }}
                  <span class="text-red" v-if="selectedTask && selectedTask.data_collection_add_description == 'Mandatory'">*</span>
                </label>

                <span
                    class="btn btn-edit float-right"
                    @click="editModeControlDescriptionDocumentationCollection = !editModeControlDescriptionDocumentationCollection"
                    v-if="!editModeControlDescriptionDocumentationCollection && taskForm.data_remarks">
                  <font-awesome-icon icon="pen"/>
                </span>

                <div v-if="(!taskForm || !taskForm.data_remarks) && !editModeControlDescriptionDocumentationCollection">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </div>

                <b-form-textarea
                  qid="assessment-form-documentation-collection-control-description"
                  v-model="taskForm.data_remarks"
                  v-if="editModeControlDescriptionDocumentationCollection"
                  rows="6"
                  max-rows="6"
                  :placeholder="$t('tasks.modal.control_description_label')"
                ></b-form-textarea>

                <div v-if="!editModeControlDescriptionDocumentationCollection" style="margin-top: -20px;">
                  <div v-if="taskForm.data_remarks && taskForm.data_remarks.length > 300">
                    <p v-if="showFullTextControlDescriptionDocumentationCollection" class="text-formatted">
                      {{ taskForm.data_remarks }}
                    </p>

                    <p v-if="!showFullTextControlDescriptionDocumentationCollection" class="text-formatted">
                      {{ taskForm.data_remarks | truncate(300) }}
                    </p>

                    <div class="text-center mt-3" @click="showFullTextControlDescriptionDocumentationCollection=!showFullTextControlDescriptionDocumentationCollection">
                      <span class="cursor-pointer" v-if="!showFullTextControlDescriptionDocumentationCollection">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullTextControlDescriptionDocumentationCollection">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>

                  <p v-if="taskForm.data_remarks && taskForm.data_remarks.length <= 300"
                     class="text-formatted"
                  >
                    {{ taskForm.data_remarks }}
                  </p>
                </div>
              </b-form-group>

              <div class="w-100" @dragover.prevent @drop.prevent="handleDropDocumentation">
                <div v-show="showDropActive" class="drop-active">
                  <h3>Drop files to upload</h3>
                </div>
                 <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                  {{ $t('attachments.label') }}
                </label>
                <span class="float-right">
                    <file-upload
                            ref="uploader"
                            v-model="data_collection_files"
                            :drop="true"
                            :multiple="true"
                            input-id="task-file"
                            @input="onDataFileChange"
                            @dropActive="showDropActiveFunction"
                            @dropInactive="hideDropActiveFunction"
                            v-if="selectedTask.status != 'completed'"
                            class="text-success cursor-pointer float:right"
                    >
                        {{ $t('tasks.modal.add_attachment_label') }}
                      </file-upload>
                </span>
              </div>
              <ul class="list-secondary" style="list-style-type: none; padding-left: 0;">
                <li v-for="(item, index) in getMedia('data_documents')" :key="index" class="text-bold list-item mb-2">
                  <span>
                    <a :href="item.url" target="_blank" class="btn" qid="download-media">
                      {{ item.full_title }}
                    </a>
                  </span>
                  <span class="actions" style="float: right;">
                    <a :href="item.url" target="_blank" class="btn" qid="download-media">
                      <font-awesome-icon icon="eye"/>
                    </a>
                    <span class="btn" @click="downloadMedia(item)" qid="download-media">
                      <font-awesome-icon icon="cloud-download-alt"/>
                    </span>
                    <span class="btn" @click="openDeleteAttachmentModal(item)" qid="remove-media-item">
                      <font-awesome-icon icon="trash-alt"/>
                    </span>
                  </span>
                </li>
                <li v-if="!getMedia('data_documents').length" qid="no-results-row-rr" class="text-center">
                  <h5 class="mt-3">{{ $t('system.no_results') }}</h5>
                </li>
              </ul>
            </div>
            <div class="col-sm-6" v-if="selectedTask.code != 'system_impact_assessment'">

              <h5>
                {{ $t('tasks.modal.data_collection_chat_title') }}
              </h5>
              <hr>
              <br>

              <div class="mt-3 mb-3">
                <div class="row">
                  <div class="col-sm-10 chat-box-col-text">
                    <b-form-textarea
                      qid="create-s-form-description"
                      v-model="comment"
                      class="chat-box-text"
                      rows="2"
                      max-rows="2"
                      :placeholder="$t('tasks.modal.question_to_recipient_label')"
                    ></b-form-textarea>
                  </div>
                  <div class="col-sm-2 chat-box-col-button cursor-pointer">
                    <div class="chat-box-button" @click="addCommentSubmit">
                      {{ $t('tasks.modal.send_button_label') }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-control scrollable-height-260 pt-3" style="background-color: white;">
                <div v-if="previousComments && previousComments.length">
                  <div v-for="(comment, index) in previousComments"
                       class="mt-2 chat-message"
                       :key="index"
                  >
                    <p>
                      <span class="cursor-pointer float-right"
                            @click="openDeleteCommentModal(comment)"
                            v-if="isCommentOwner(comment)"
                            qid="view-p-remove-link"
                      >
                        <font-awesome-icon icon="trash-alt" />
                      </span>
                      <Avatar :object="comment.user" size="xs"></Avatar>
                      <span class="ml-1">
                        {{ comment.user.name }}
                      </span>
                      {{$t('system.on')}}
                      <span class="text-normal">
                        {{ comment.updated_at | formatDateTime }}
                      </span>
                    </p>
                    <div v-if="comment.comment && comment.comment.length > 300">
                      <p v-if="comment.expanded" class="text-formatted">{{ comment.comment }}</p>

                      <p v-if="!comment.expanded" class="text-formatted">{{ comment.comment | truncate(300) }}</p>

                      <div class="text-center mt-3" @click="comment.expanded=!comment.expanded">
                        <span class="cursor-pointer" v-if="!comment.expanded">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down"/>
                        </span>
                        <span class="cursor-pointer" v-if="comment.expanded">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up"/>
                        </span>
                      </div>
                    </div>

                    <p v-if="comment.comment && comment.comment.length <= 300" class="text-formatted">{{ comment.comment }}</p>
                  </div>
                </div>
                <div v-if="!previousComments.length" class="text-center">
                  <h5 class="mt-3">
                    {{ $t('system.no_results') }}
                  </h5>
                </div>
              </div>
            </div>

          </div>
        </div>
      </b-form>

      <!-- Update measures task -->
      <div class="form-container mt-0 mb-2" v-if="selectedTask && selectedTask.code == 'update_measures'">
        <div class="row mt-1">

          <!-- Tables container -->
          <div class="col-sm-12" v-if="selectedTask.project">
            <MeasuresTable :object="selectedTask.project" :showOnTask="true"></MeasuresTable>
          </div>

        </div>
      </div>


      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="task-modal-info" v-if="selectedTask && selectedTask.id">
            <div class="row">
              <div class="col text-center pt-3 pb-3" v-if="currentView != 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.task_assignees') }}</strong>
                </div>
                <span v-if="selectedTask.users && selectedTask.users.length">
                  <span class="mr-1 text-normal"
                        v-for="(user, index) in getReducedUsers(selectedTask.users)"
                        :key="index"
                  >
                    <span qid="profile-photo">
                      <Avatar :object="user" size="xs"></Avatar>
                    </span>
                  </span>
                </span>
                <span v-if="selectedTask.users && selectedTask.users.length && selectedTask.users.length > 3"
                      class="badge cursor-pointer"
                      @click="openUsersModal(selectedTask)"
                >
                  <font-awesome-icon icon="users"/>
                  + {{ selectedTask.users.length - 3 }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3" v-if="currentView == 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.task_assignees') }}</strong>
                </div>

                <span v-if="selectedTask.data_users && selectedTask.data_users.length">
                  <span class="mr-1 text-normal"
                        v-for="(user, index) in getReducedUsers(selectedTask.data_users)"
                        :key="index"
                  >
                    <span qid="profile-photo">
                      <Avatar :object="user" size="xs"></Avatar>
                    </span>
                  </span>
                </span>
                <span v-if="selectedTask.data_users && selectedTask.data_users.length && selectedTask.data_users.length > 3"
                      class="badge cursor-pointer"
                      @click="openUsersModal(selectedTask)"
                >
                  <font-awesome-icon icon="users"/>
                  + {{ selectedTask.data_users.length - 3 }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('table.due_date') }}</strong>
                </div>
                <span class="text-normal" v-if="selectedTask.project && currentView != 'data_collection'">
                  <span v-if="getDifference(selectedTask.project.end_date) > 3">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-1"/>
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span v-if="getDifference(selectedTask.project.end_date) <= 3 && getDifference(selectedTask.project.end_date) >= 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-6"/>
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span v-if="getDifference(selectedTask.project.end_date) < 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-12"/>
                    {{ Math.abs(getDifference(selectedTask.project.end_date)) }}
                    {{ $t('system.days') }}
                    {{ $t('system.overdue') }}
                  </span>
                </span>
                <span class="text-normal" v-if="selectedTask.project && currentView == 'data_collection'">
                  <span v-if="getDifference(selectedTask.project.data_collection_end_date) > 3">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-1"/>
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.data_collection_end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span v-if="getDifference(selectedTask.project.data_collection_end_date) <= 3 && getDifference(selectedTask.project.data_collection_end_date) >= 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-6"/>
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.data_collection_end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span v-if="getDifference(selectedTask.project.data_collection_end_date) < 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-12"/>
                    {{ Math.abs(getDifference(selectedTask.project.data_collection_end_date)) }}
                    {{ $t('system.days') }}
                    {{ $t('system.overdue') }}
                  </span>
                  <span v-if="!selectedTask.project.data_collection_end_date">
                    {{ $t('system.n_a') }}
                  </span>
                </span>
              </div>
              <div class="col text-center pt-3 pb-3" v-if="currentView != 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('system.task_status') }}</strong>
                </div>
                <span v-if="selectedTask.status === 'completed'" >
                  <font-awesome-icon icon="check-circle" class="icon-success"/>
                </span>
                <span v-if="selectedTask.status === 'pending'" class="pr-1">
                  <font-awesome-icon
                      icon="exclamation-triangle"
                      class="risk-6"
                  />
                </span>
                <span class="text-normal">
                  {{ $t('system.' + $options.filters.slugify(selectedTask.status)) }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3" v-if="currentView == 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('tasks.table.data_collection_status') }}</strong>
                </div>
                <span v-if="selectedTask.data_status && selectedTask.data_status === 'completed'" >
                  <font-awesome-icon icon="check-circle" class="icon-success"/>
                </span>
                <span v-if="selectedTask.data_status && selectedTask.data_status === 'pending'" class="pr-1">
                  <font-awesome-icon
                      icon="exclamation-triangle"
                      class="risk-6"
                  />
                </span>
                <span v-if="selectedTask.data_status">
                  {{ $t('system.' + $options.filters.slugify(selectedTask.data_status)) }}
                </span>
                <span v-if="!selectedTask.data_status">
                  <font-awesome-icon
                      icon="exclamation-triangle"
                      class="risk-6"
                  />
                  {{ $t('system.pending') }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('table.project') }}</strong>
                </div>
                <span v-if="selectedTask.project">
                  <span v-if="isOwner(selectedTask.project)" class="text-success breadcrumb-item cursor-pointer" @click="navigateToProject(selectedTask)">
                    <font-awesome-icon icon="calendar-alt" class="mr-1"/>
                    {{ selectedTask.project.title }}
                  </span>
                  <span v-if="!isOwner(selectedTask.project)" class="text-success breadcrumb-item" style="pointer-events:none;">
                    <font-awesome-icon icon="calendar-alt" class="mr-1"/>
                    {{ selectedTask.project.title }}
                  </span>
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.owners_label') }}</strong>
                </div>
                <span v-if="selectedTask.project">
                  <span v-if="selectedTask.project && selectedTask.project.users && selectedTask.project.users.length">
                    <span class="mr-1 text-normal"
                          v-for="(user, index) in getReducedUsers(selectedTask.project.users)"
                          :key="index"
                    >
                      <span qid="profile-photo">
                        <Avatar :object="user" size="xs"></Avatar>
                      </span>
                    </span>
                  </span>
                  <span v-if="selectedTask.project.users.length > 3"
                        class="badge cursor-pointer"
                        @click="openUsersModal(selectedTask.project)"
                  >
                    <font-awesome-icon icon="users"/>
                    + {{ selectedTask.project.users.length - 3 }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">
                <span>
                  <vm-progress
                      type="circle"
                      :percentage="project_progress"
                      style="vertical-align: middle;"
                      :width="50"
                      :stroke-width="2"
                      stroke-color="#00c29e"
                  >
                    {{project_progress}}%
                  </vm-progress>
                </span>
                <span class="btn btn-link cursor-pointer text-bold ml-3" @click="showListOfTasks()">
                  {{ $t('tasks.show_list_label') }}
                </span>
                <CreateObservationModal
                  :object="selectedTask.project"
                  :task="selectedTask"
                  type="secondary"
                  v-if="isOwner(selectedTask) && currentView != 'data_collection' && selectedTask.code != 'update_measures'"
                ></CreateObservationModal>
              </div>
              <div class="col-sm-6 text-right">
                <!-- <b-button @click="previousTask()"
                          class="mt-2"
                          variant="secondary"
                          :disabled="buttonDisabled || taskList.length == 1"
                          qid="create-p-submit-button"
                >
                  < {{ $t('tasks.modal.previous_question') }}
                </b-button> -->
                <b-button class="ml-3 mt-2"
                          variant="success"
                          v-if="selectedTask.status != 'completed' && selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'"
                          @click="completeTask()"
                          :disabled="loadingFullList || buttonDisabled || !taskList.length"
                          qid="create-p-cancel-button"
                >
                  {{ $t('tasks.modal.complete') }}
                </b-button>
                <b-button class="ml-3 mt-2"
                          variant="secondary"
                          v-if="selectedTask.status !== 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView === 'data_collection'"
                          @click="saveDataTask()"
                          :disabled="buttonDisabled"
                          qid="task-modal-save_without_complete-button"
                >
                  {{ $t('system.save_without_complete') }}
                </b-button>
                <b-button class="ml-3 mt-2"
                          variant="success"
                          @click="completeDataTask()"
                          :disabled="buttonDisabled"
                          qid="create-p-cancel-button"
                          v-if="selectedTask.data_status != 'completed' && selectedTask.code != 'system_impact_assessment' && currentView == 'data_collection'"
                >
                  {{ $t('tasks.modal.complete') }}
                </b-button>
                <b-button class="ml-3 mt-2"
                          variant="success"
                          v-if="selectedTask.code == 'system_impact_assessment'"
                          @click="completeSystemRiskTask()"
                          :disabled="loadingFullList || buttonDisabled || !taskList.length"
                          qid="create-p-cancel-button"
                >
                  {{ $t('tasks.modal.complete') }}
                </b-button>
                <b-button @click="nextTask()"
                          class="ml-3 mt-2"
                          variant="secondary"
                          :disabled="loadingFullList || buttonDisabled || taskList.length == 1 || !taskList.length"
                          qid="create-p-submit-button"
                >
                  {{ $t('system.skip') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <b-modal ref="all-done"
             hide-footer
             @hide="hideDoneModal"
             size="lg"
             modal-class="all-done-modal"
    >

      <template #modal-header="{ close }">
        <div class="text-center pt-2 pb-2" style="width: 100%;">
          <span @click="hideDoneModal" class="btn btn-secondary btn-sm cursor-pointer float-right">
            <font-awesome-icon icon="times"/>
          </span>
          <h3>DONE!!!</h3>
        </div>
      </template>

      <img width="100%" src="@/assets/allDoneGif.gif" alt="">

    </b-modal>


    <!-- Change user modal template -->
    <b-modal ref="reopen-task" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideReopenDataCollectionModal" class="btn btn-secondary cursor-pointer float-right">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center">
            {{ $t('tasks.table.data_collection_assignee') }}
          </h5>
        </div>
      </template>

      <div class="form-container">

        <b-alert v-if="reopenError.length"
                 show
                 variant="danger"
                 qid="create-p-error"
        >
          {{ reopenError }}
        </b-alert>

        <b-form-group>
          <label qid="create-p-users-label">
            {{ $t('tasks.modal.recipient_label') }}
          </label>

          <div class="multiselect-row">
            <multiselect
                v-model="selectedAssignUsers"
                :options="userList"
                :multiple="true"
                :taggable="false"
                :disabled="buttonDisabled"
                track-by="slug"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('tasks.modal.recipient_label')"
                label="name"
                qid="create-p-users-select"
            >
              <template slot="tag" slot-scope="props">
                <span class="mr-3 user-tag">
                  <Avatar :object="props.option" size="xs"></Avatar>
                  <span class="ml-2">{{ props.option.name }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>

            <UserInviteModal
                  :buttonType="'small'"
                  :buttonDisabled=buttonDisabled
                  @reloadUserList="reloadUserList"
            ></UserInviteModal>
          </div>
        </b-form-group>
      </div>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="text-right">
              <b-button class=""
                        variant="secondary"
                        @click="hideReopenDataCollectionModal"
                        qid="edit-p-cancel-button"
              >
                {{ $t('maintenance.measures.create.cancel') }}
              </b-button>
              <b-button
                        class="ml-3"
                        variant="success"
                        :disabled="buttonDisabled"
                        @click="changeUsersSubmit()"
                        qid="edit-p-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('maintenance.measure_categories.create.submit') }}
              </b-button>
            </div>
          </div>
        </div>

      </template>
    </b-modal>


    <!-- Add new link modal -->
    <b-modal ref="add-link"
             @hide="hideCreateLinkModal"
             modal-class="task-modal"
             hide-footer
    >
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateLinkModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-user-title">
            {{ $t('tasks.modal.add_links_button') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-user-error"
      >
        {{ error }}
      </b-alert>

      <div class="form-container">
        <b-form-group>
          <div>
            <label class="mt-2">{{ $t('system.link') }}</label>
            <b-form-input
              type="text"
              aria-describedby="inputGroup"
              v-model="inputLink"
              :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
              qid="create-p-links"
            ></b-form-input>
            <label class="mt-2">{{ $t('table.name') }}</label>
            <b-form-input
              type="text"
              aria-describedby="inputGroup"
              v-model="inputLinkName"
              :placeholder="inputLink ? inputLink : $t('table.name')"
              qid="create-p-links"
            ></b-form-input>
          </div>
        </b-form-group>
      </div>
      <div class="proxy-footer">
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="col-sm-6">

            </div>
            <div class="col-sm-6">
              <div class="text-right">
                <b-button class=""
                          variant="secondary"
                          @click="hideCreateLinkModal"
                          qid="edit-user-cancel-button"
                >
                  {{ $t('administration.users.create.cancel') }}
                </b-button>
                <b-button @click="handleLink"
                          class="ml-3"
                          variant="success"
                          :disabled="buttonDisabled"
                          qid="edit-user-submit-button"
                >
                  <span v-if="buttonDisabled" class="mr-1">
                    <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                  </span>
                  {{ $t('maintenance.users.merge_users_submit') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>


    <ConfirmRemoveAttachment
        :object="selectedFile"
        :show="showDeleteAttachmentModal"
        type="file"
        @closeConfirmModal="closeDeleteAttachmentModal"
    ></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment
        :object="selectedLink"
        :show="showDeleteLinkModal"
        type="link"
        @closeConfirmModal="closeDeleteLinkModal"
    ></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment
        :object="selectedComment"
        :task="selectedTask"
        :show="showDeleteCommentModal"
        type="comment"
        @closeConfirmModal="closeDeleteCommentModal"
    ></ConfirmRemoveAttachment>

    <GuideViewModal
        :guide="selectedGuide"
        :showModal="viewGuideModal"
        @closeViewModal="closeViewGuideModal"
    ></GuideViewModal>

    <ShowMoreModal
        :items="selectedItem.users"
        :show="showUsersModal"
        @closeViewModal="closeUsersModal"
        type="users"
    ></ShowMoreModal>

  </span>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import Datepicker from 'vuejs-datepicker';
  import {config} from '@/config.js';
  import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
  import GuideViewModal from '@/components/guide/GuideViewModal.vue';
  import roleCheck from '@/util/ACL/roleCheck';
  import Avatar from '@/components/Avatar.vue';
  import ShowMoreModal from '@/components/ShowMoreModal.vue';
  // import draggable from 'vuedraggable';
  import CreateObservationModal from '@/views/Projects/CreateObservationModal.vue';
  // import AssessmentGlobalExpandable from '@/components/tasks/AssessmentGlobalExpandable.vue';
  import MeasuresTable from '@/views/Projects/MeasuresTable.vue';


  export default {
    name: 'AssessmentGlobalTaskModal',
    data: function() {
      return {
        taskForm: {
          remarks: '',
          notes: '',
          data_remarks: '',
          control_description: '',
          performed_text: '',
          rto: '',
          rpo: ''
        },
        selectedTask: [],
        buttonDisabled: false,
        selectedFile: {},
        selectedLink: {},
        selectedComment: {},
        showDeleteAttachmentModal: false,
        showDeleteLinkModal: false,
        showDeleteCommentModal: false,
        showInput: false,
        showSingleLinkLabel: true,
        inputLink: '',
        inputLinkName: '',
        descriptionLength: config.descriptionLength,
        showFullProjectMessage: false,
        showFullTaskDescription: false,
        showFullDataCollectionDescription: false,
        showFullGenericControlDescription: false,
        error: '',
        sizeError: '',
        taskList: [],
        selectedAnswer: [],
        selectedDate: '',
        selectedDataCollectionAnswer: [],
        allAnswers: [],
        impactItems: [
          { name: this.$t('impact.very_low'), value: 'Very low' },
          { name: this.$t('impact.low'), value: 'Low' },
          { name: this.$t('impact.high'), value: 'High' },
          { name: this.$t('impact.very_high'), value: 'Very high' }
        ],
        intervalOptions: [
          {text: this.$t('system.interval_seconds'), value: 'Seconds'},
          {text: this.$t('system.interval_minutes'), value: 'Minutes'},
          {text: this.$t('system.interval_hours'), value: 'Hours'},
          {text: this.$t('system.interval_days'), value: 'Days'},
          {text: this.$t('system.interval_months'), value: 'Months'},
          {text: this.$t('system.interval_years'), value: 'Years'},
        ],
        selectedConfidentialityImpact: [],
        selectedIntegrityImpact: [],
        selectedAvailabilityImpact: [],
        rtoInterval: [],
        rpoInterval: [],
        project_progress: 0,
        taskCompleted: false,
        welcomeGuide: {},
        selectedGuide: {},
        viewGuideModal: false,
        selectedItem: {},
        showUsersModal: false,
        currentView: '',
        files: [],
        data_collection_files: [],
        showLinksSection: false,
        showDataCollectionLinksSection: false,
        uploader: false,
        showDropActive: false,
        userList: [],
        comment: '',
        reopenError: '',
        selectedAssignUsers: [],
        previousComments: [],
        showFullGuideDescription: false,
        wpGuide: {},
        wpGuideData: {},
        wpGuideSystem: {},
        myGuides: [],
        myGuidesData: [],
        myGuidesSystem: [],

        editModeResponse: false,
        editModeNotes: false,
        editModeControlDescription: false,
        editModePerformedTest: false,
        editModeConclusion: false,
        editModeControlDescriptionDocumentationCollection: false,

        showFullTextNotes: false,
        showFullTextControlDescription: false,
        showFullTextPerformedTest: false,
        showFullTextConclusion: false,
        showFullTextControlDescriptionDocumentationCollection: false,
        assessmentGlobalExpandableShow: false,

      }
    },
    props: {
      task: {},
      tasks: {},
      fromHomepage: {},
      selectedTaskType: String
    },
    components: {
      Datepicker,
      ConfirmRemoveAttachment,
      GuideViewModal,
      Avatar,
      ShowMoreModal,
      // draggable,
      MeasuresTable,
      CreateObservationModal,
      // AssessmentGlobalExpandable,
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getUser() {
        return this.$store.state.user
      },
      getWordpressLink() {
        return this.$store.state.wordpressLink
      },
      getReportMedia() {
        let media = []

        media = _.filter(this.selectedTask.project.media, function(mediaItem) {
          return mediaItem.collection_name == 'documents' || mediaItem.collection_name == 'project';
        });

        return media
      },
      getReportLinks() {
        let links = []

        links = _.filter(this.selectedTask.project.links, function(link) {
          return link.collection == null;
        });

        return links
      }
    },
    watch: {
      getClient: function () {

      }
    },
    methods: {
      getMedia(type) {
        let media = []
        if (type == 'task') {
          media = _.filter(this.selectedTask.media, function(mediaItem) {
            return mediaItem.collection_name == 'documents';
          });
        }

        if (type == 'data_documents') {
          media = _.filter(this.selectedTask.media, function(mediaItem) {
            return mediaItem.collection_name == 'data_documents';
          });
        }

        if (type == 'task_and_data_collection') {
          media = _.filter(this.selectedTask.media, function(mediaItem) {
            return mediaItem.collection_name == 'documents' || mediaItem.collection_name == 'data_documents';
          });
        }

        if (type == 'question') {
          media = _.filter(this.selectedTask.media, function(mediaItem) {
            return mediaItem.collection_name == 'question';
          });
        }

        if (type == 'data_collection') {
          media = _.filter(this.selectedTask.media, function(mediaItem) {
            return mediaItem.collection_name == 'data_collection';
          });
        }
        return media
      },
      getDifference(endDate) {
        var moment = require('moment');
        let currentDate = moment()
        endDate = moment(endDate);
        let difference = endDate.diff(currentDate, 'days');
        return difference;
      },
      openGuide() {
        if (this.wpGuide && this.wpGuide.link) {
          window.open(this.wpGuide.link, '_blank')
        }
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Task' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Task',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
            piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function(response) {
              self.wpGuide = response.data
            }, function() {});
          }
        }, function() {});
      },
      loadGuidesData(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Task',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
            piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function(response) {
              self.wpGuideData = response.data
            }, function() {});
          }
        }, function() {});
      },
      loadGuidesSystem(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Task',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
            piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function(response) {
              self.wpGuideSystem = response.data
            }, function() {});
          }
        }, function() {});
      },
      getLinks(type) {
        let links = []
        if (type == 'task') {
          links = _.filter(this.selectedTask.links, function(link) {
            return link.collection == 'task';
          });
        }

        if (type == 'question') {
          links = _.filter(this.selectedTask.links, function(link) {
            return link.collection == 'question' || link.collection == null;
          });
        }

        if (type == 'data_documents') {
          links = _.filter(this.selectedTask.links, function(link) {
            return link.collection == 'data_documents';
          });
        }

        if (type == 'task_and_data_collection') {
          links = _.filter(this.selectedTask.links, function(link) {
            return link.collection == 'data_documents' || link.collection == 'task';
          });
        }

        if (type == 'data_collection') {
          links = _.filter(this.selectedTask.links, function(link) {
            return link.collection == 'data_collection';
          });
        }
        return links
      },
      getReducedUsers(users) {
        let reducedUsers = []
        if (users) {
          if (users.length > 3) {
            reducedUsers = _.cloneDeep(users);
            reducedUsers = reducedUsers.slice(0, 3);
          } else {
            reducedUsers = users;
          }
        }
        return reducedUsers;
      },
      getIcon(object) {
        let foundObject = {}
        let responseOptions = JSON.parse(object.response_type_options)

        foundObject = _.find(responseOptions, function(item) {
          return item.title === object.response;
        });

        if (foundObject) {
          return foundObject.value.value
        } else {
          return ''
        }

      },
      showCreateLinkModal(object) {
        let self = this;
        this.error = '';
        this.buttonDisabled = false;

        this.$refs['add-link'].show()
      },
      hideCreateLinkModal() {
        this.$refs['add-link'].hide()
      },
      reloadUserList() {
        this.loadUsers();
      },
      loadUsers(query) {
        let self = this;

        this.buttonDisabled = false;

        piincHttp.get('users', { params:
          {
            client: this.getClient.id,
            keyword: query ? query : undefined,
            per_page: 100
          }
        }).then(function(response) {
          self.userList = response.data.items;
          self.buttonDisabled = false;
        }, function() {});
      },
      loadLinkedControls() {
        let self = this;

        this.buttonDisabled = false;

        piincHttp.get('projects/' + this.selectedTask.project.slug + '/tasks/me/linked', { params:
            {
              task_id: this.selectedTask.id,
              keyword: query ? query : undefined,
              per_page: 100
            }
        }).then(function(response) {
          self.userList = response.data.items;
          self.buttonDisabled = false;
        }, function() {});
      },
      showReopenDataCollectionModal(object) {
        let self = this;
        this.comment = '';
        this.reopenError = '';

        this.selectedAssignUsers = [];

        this.loadUsers();

        _.forEach(self.selectedTask.data_users, function (user) {
          self.selectedAssignUsers.push(user)
        })

        this.$refs['reopen-task'].show();
      },
      hideReopenDataCollectionModal() {
        this.selectedAssignUsers = []
        this.$refs['reopen-task'].hide()
      },
      loadComments() {
        let self = this;
        this.previousComments = []
        piincHttp.get('tasks/' + this.selectedTask.id + '/comments', { params:
          {
            client: this.getClient.id,
            per_page: 100,
            sort: 'created_at',
            order: 'desc'
          }
        }).then(function(response) {
          self.previousComments = []

          _.forEach(response.data.items, function (item) {
            item.expanded = false;
            self.previousComments.push(item)
          })

        }, function() {});
      },
      openUsersModal(object) {
        this.selectedItem = object
        this.showUsersModal = true
      },
      closeUsersModal() {
        this.selectedItem = {}
        this.showUsersModal = false
      },
      switchCurrentView(type) {
        console.log('ACTIVE VIEW ' + type)
        this.showLinksSection = false;
        this.showDataCollectionLinksSection = false;
        this.loadComments()
        this.currentView = type;
        if (type == 'default') {
          this.loadGuides('assessment_task')
        } else {
          this.loadGuidesData('data_collection_task')
        }

      },
      showListOfTasks() {
        this.hideTaskModal()
        this.$emit('showViewModal');
      },
      showTaskModal(object) {
        let self = this;
        let perPage = 100
        this.error = '';
        this.showLinksSection = false;
        this.showDataCollectionLinksSection = false;

        if (object != null) {
          this.selectedTask = object
          this.loadTaskById(this.selectedTask.id, true);
          this.populateForm()
          if (this.tasks && this.tasks.id) {
            self.loadingFullList = true
            piincHttp.get('projects/' + this.tasks.slug + '/tasks/me/small', { params:
              {
                status: 'pending',
                per_page: perPage,
              }
            }).then(function(response) {
              self.taskList = response.data.items;
              self.loadingFullList = false
              // Checking the type of the users so the right view is displayed
              if (self.isOwner(self.selectedTask) && self.selectedTaskType != 'doc_collection_tasks') {
                self.switchCurrentView('default')
                if (self.selectedTask.code == 'update_measures') {
                  self.loadGuidesSystem('system_description_task')
                } else {
                  self.loadGuides('assessment_task')
                }
              } else {
                if (self.isDataOwner(self.selectedTask)) {
                  self.switchCurrentView('data_collection')
                  self.loadGuidesData('data_collection_task')
                }
              }
            }, function() {});
          }
        }

        if (object == null && this.tasks && this.tasks.length) {
          this.selectedTask = this.tasks[0]
          this.loadTaskById(this.selectedTask.id, true);
          this.populateForm()
          // Checking the type of the users so the right view is displayed
          if (this.isOwner(this.selectedTask)) {
            // this.currentView = 'default'
            if (this.selectedTask.code == 'update_measures') {
              self.loadGuidesSystem('system_description_task')
            } else {
              self.loadGuides('assessment_task')
            }
          } else {
            if (this.isDataOwner(this.selectedTask)) {
              self.currentView = 'data_collection'
              self.loadGuidesData('data_collection_task')
            }
          }
        }

        if (object == null && this.tasks && this.tasks.id) {
          self.loadingFullList = true
          piincHttp.get('projects/' + this.tasks.slug + '/tasks/me', { params:
            {
              status: 'pending',
              per_page: 1,
            }
          }).then(function(response) {
            self.selectedTask = response.data.items[0];
            self.loadTaskById(self.selectedTask.id, true);
            self.populateForm()
            piincHttp.get('projects/' + self.tasks.slug + '/tasks/me/small', { params:
              {
                status: 'pending',
                per_page: perPage,
              }
            }).then(function(response) {
              self.taskList = response.data.items;
              self.loadingFullList = false

              // Checking the type of the users so the right view is displayed
              if (self.isOwner(self.selectedTask)) {
                self.switchCurrentView('default')
                if (self.selectedTask.code == 'update_measures') {
                  self.loadGuidesSystem('system_description_task')
                } else {
                  self.loadGuides('assessment_task')
                }
              } else {
                if (self.isDataOwner(self.selectedTask)) {
                  self.switchCurrentView('data_collection')
                  self.loadGuidesData('data_collection_task')
                }
              }
            }, function() {});
          }, function() {});
        }

        console.log('CREATED ' + this.selectedTaskType)
        if (this.selectedTaskType === 'doc_collection_tasks') {
          console.log('SWITCH VIEW data_collection')
          self.switchCurrentView('data_collection')
        } else if(this.selectedTaskType === 'main_tasks') {
          console.log('SWITCH VIEW default')
          self.switchCurrentView('default')
        }
        console.log('VIEW ' + this.currentView)
        this.$refs['task-modal'].show()
        // this.loadTaskGuide()
      },
      hideTaskModal() {
        let self = this;
        this.error = '';

        this.editModeResponse = false;
        this.editModeNotes = false;
        this.editModeControlDescription = false;
        this.editModePerformedTest = false;
        this.editModeConclusion = false;
        this.editModeControlDescriptionDocumentationCollection = false;

        this.taskForm.response = '';
        this.taskForm.notes = '';
        this.taskForm.control_description = '';
        this.taskForm.performed_text = '';
        this.taskForm.remarks = '';
        this.taskForm.data_remarks = '';
        this.taskForm.rto = '';
        this.taskForm.rpo = '';
        this.selectedAnswer = [];
        this.selectedDate = '';
        this.selectedDataCollectionAnswer = [];

        setTimeout(function(){
          self.$emit('reloadContent');
          self.selectedTask = {}
        }, 500);

        self.$store.commit('storeUpdateTasks', true);

        this.$refs['task-modal'].hide()
      },
      navigateToProject(task) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', task);
        this.$router.push({ name: 'projects.view', params: { slug: task.project.slug }})
      },
      showViewGuideModal(object) {
        this.selectedGuide = object
        this.viewGuideModal = true
      },
      closeViewGuideModal() {
        this.selectedGuide = ''
        this.viewGuideModal = false
      },
      populateForm(data_remarks = '') {
        let self = this;

        self.taskForm.remarks = self.selectedTask.remarks;
        self.taskForm.notes = self.selectedTask.notes;
        self.taskForm.control_description = self.selectedTask.control_description;
        self.taskForm.performed_text = self.selectedTask.performed_text;

        console.log('DATA' + data_remarks)
        if(!data_remarks){
          self.taskForm.data_remarks = self.selectedTask.data_remarks;
        }


        self.allAnswers = [];
        if (self.selectedTask && self.selectedTask.response_type_options) {
          try {
            self.allAnswers = JSON.parse(self.selectedTask.response_type_options);
          } catch (error) {
            console.error("Failed to parse JSON:", error);
          }
        } else {
          console.warn("response_type_options is undefined or null");
        }


        self.selectedAnswer = []
        if (self.selectedTask.response) {
          if (self.selectedTask.response_type != 'Datepicker') {
            self.selectedAnswer = _.find(self.allAnswers, function(item) {
              if (item.title === self.selectedTask.response){
                return self.selectedTask.response;
              }
            });
          } else {
            self.selectedDate = self.selectedTask.response;
          }
        }

        self.selectedDataCollectionAnswer = []
        if (self.selectedTask.data_response) {
          self.selectedDataCollectionAnswer = _.find(self.allAnswers, function(item) {
            if(item === self.selectedTask.data_response){
              return self.selectedTask.data_response;
            }
          });
        }

        if (!self.selectedAnswer.title && !self.selectedDate.length) {
          self.editModeResponse = true;
        }
        if (!self.taskForm.notes || !self.taskForm.notes.length) {
          self.editModeNotes = true;
        }
        if (!self.taskForm.control_description || !self.taskForm.control_description.length) {
          self.editModeControlDescription = true;
        }
        if (!self.taskForm.performed_text || !self.taskForm.performed_text.length) {
          self.editModePerformedTest = true;
        }
        if (!self.taskForm.remarks || !self.taskForm.remarks.length) {
          self.editModeConclusion = true;
        }
        if (!self.taskForm.data_remarks || !self.taskForm.data_remarks.length) {
          self.editModeControlDescriptionDocumentationCollection = true;
        }

        this.selectedConfidentialityImpact = []
        if (self.selectedTask.confidentiality) {
          self.selectedConfidentialityImpact = _.find(self.impactItems, function(item) {
            if(item.value === self.selectedTask.confidentiality){
              return item
            }
          });
        }

        this.selectedIntegrityImpact = []
        if (self.selectedTask.integrity) {
          self.selectedIntegrityImpact = _.find(self.impactItems, function(item) {
            if(item.value === self.selectedTask.integrity){
              return item
            }
          });
        }

        this.selectedAvailabilityImpact = []
        if (self.selectedTask.availability) {
          self.selectedAvailabilityImpact = _.find(self.impactItems, function(item) {
            if(item.value === self.selectedTask.availability){
              return item
            }
          });
        }

        this.rtoInterval = []
        if (self.selectedTask.rto_type) {
          self.rtoInterval = _.find(self.intervalOptions, function(item) {
            if(item.value === self.selectedTask.rto_type){
              return item
            }
          });
        }

        this.rpoInterval = []
        if (self.selectedTask.rpo_type) {
          self.rpoInterval = _.find(self.intervalOptions, function(item) {
            if(item.value === self.selectedTask.rpo_type){
              return item
            }
          });
        }

        this.taskForm.rto = this.selectedTask.rto_number
        this.taskForm.rpo = this.selectedTask.rpo_number

      },
      openWelcomePage() {
        this.showViewGuideModal(this.welcomeGuide)
      },
      showDropActiveFunction(value) {
        this.showDropActive = value;
      },
      navigateToTask(object) {
        if (this.isOwner(object.model)) {
          this.$store.commit('storeTaskToolbarState', true);
          this.$store.commit('storeActiveTask', object);
          if (object.model_type == 'App\\Activity\\Models\\Activity') {
            this.$router.push({ name: 'activities.view', params: { slug: object.model.slug }, query: { task: object.id }})
          }
          if (object.model_type == 'App\\Process\\Models\\Process') {
            this.$router.push({ name: 'processes.view', params: { slug: object.model.slug }, query: { task: object.id }})
          }
          if (object.model_type == 'App\\System\\Models\\System') {
            this.$router.push({ name: 'systems.view', params: { slug: object.model.slug, }, query: { task: object.id }})
          }
          if (object.model_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
            this.$router.push({ name: 'contracts.view', params: { slug: object.model.slug, }, query: { task: object.id }})
          }
        }
      },
      isOwner(object) {
        let self = this;
        let allow = false;
        let existingUser = _.find(object.users, function(user) {
          return user.id == self.getUser.id
        });

        if (existingUser) {
          allow = true
        } else {
          if (this.getUser.isAdmin) {
            allow = true
          }
        }

        return allow
      },
      isDataOwner(object) {
        let self = this;
        let allow = false;
        let existingUser = _.find(object.data_users, function(user) {
          return user.id == self.getUser.id
        });

        if (existingUser) {
          allow = true
        } else {
          if (this.getUser.isAdmin) {
            allow = true
          }
        }

        return allow
      },
      isCommentOwner(object) {
        let self = this;
        let allow = false;
        let existingUser = object.user.id == this.getUser.id

        if (existingUser) {
          allow = true
        } else {
          if (this.getUser.isAdmin) {
            allow = true
          }
        }

        return allow
      },
      navigateToTaskScope(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        if (object.scope_type == 'App\\Activity\\Models\\Activity') {
          this.$router.push({ name: 'activities.view', params: { slug: object.scope.slug }, query: { task: object.id }})
        }
        if (object.scope_type == 'App\\Process\\Models\\Process') {
          this.$router.push({ name: 'processes.view', params: { slug: object.scope.slug }, query: { task: object.id }})
        }
        if (object.scope_type == 'App\\System\\Models\\System') {
          this.$router.push({ name: 'systems.view', params: { slug: object.scope.slug, }, query: { task: object.id }})
        }
        if (object.scope_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          this.$router.push({ name: 'contracts.view', params: { slug: object.scope.slug, }, query: { task: object.id }})
        }
      },
      hideDoneModal() {
        this.$refs['all-done'].hide()
        this.doNotMinimize = true
        this.$refs['task-modal'].hide()
        this.$emit('reloadContent');
        this.$store.commit('storeUpdatePage', true);
        this.$store.commit('storeTaskToolbarState', false);
        this.$store.commit('storeActiveTask', {});
      },
      minimizeTask() {
        this.saveTask();
        var element = document.getElementsByClassName('modal');
        element[0].classList.add("bottom-left");
        // this.submitForm = true
        this.$store.commit('storeActiveTask', this.selectedTask);
        this.$store.commit('storeTaskToolbarState', true);
      },
      addCommentSubmit() {
        let self = this;
        self.buttonDisabled = false;

        let formData = new FormData();

        formData.append("comment", self.comment);

        piincHttp.post('tasks/' + self.selectedTask.id + '/comments', formData).then(function() {
          self.loadTaskById(self.selectedTask.id, true);
          self.loadComments()
          self.showInput = false
          self.comment = '';
        }, function() {})
      },
      changeUsersSubmit() {
        let self = this;
        let userIds = [];

        if (this.selectedAssignUsers && this.selectedAssignUsers.length) {
          for (var i = 0; i < this.selectedAssignUsers.length; i++) {
            userIds.push(this.selectedAssignUsers[i].id);
          }
        }

        if (this.selectedAssignUsers && this.selectedAssignUsers.length) {
          piincHttp.put('tasks/' + self.selectedTask.id, {
            data_users: userIds
          }).then(function(response) {
            self.buttonDisabled = false;
            self.loadTaskById(self.selectedTask.id, true);
            self.hideReopenDataCollectionModal();
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.reopenError = '';
          self.buttonDisabled = false;
          if (this.selectedAssignUsers && !this.selectedAssignUsers.length) {
            this.reopenError += ' ' + this.$t('tasks.modal.recipient_error_message')
          }
        }
      },
      reopenFormSubmit() {
        this.buttonDisabled = true;
        let self = this;

        piincHttp.put('tasks/' + self.selectedTask.id, {
          data_status: 'pending',
        }).then(function(response) {
          self.buttonDisabled = false;
          self.loadTaskById(self.selectedTask.id, true);
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })

      },
      completeTask() {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        var moment = require('moment');
        let responseAnswer = '';

        if (
          ((this.selectedTask && this.selectedTask.add_attachments == 'Mandatory' && ((this.selectedTask.media && this.selectedTask.media.length) || (this.selectedTask.links && this.selectedTask.links.length))) ||
          (this.selectedTask && this.selectedTask.add_attachments != 'Mandatory')) &&
          ((this.selectedTask && this.selectedTask.add_description == 'Mandatory' && this.taskForm.remarks) ||
          (this.selectedTask && this.selectedTask.add_description != 'Mandatory')) &&
          ((this.selectedTask && this.selectedTask.add_control_description == 'Mandatory' && this.taskForm.control_description) ||
          (this.selectedTask && this.selectedTask.add_control_description != 'Mandatory')) &&
          ((this.selectedTask && this.selectedTask.add_notes == 'Mandatory' && this.taskForm.notes) ||
          (this.selectedTask && this.selectedTask.add_notes != 'Mandatory')) &&
          ((this.selectedTask && this.selectedTask.add_performed_text == 'Mandatory' && this.taskForm.performed_text) ||
          (this.selectedTask && this.selectedTask.add_performed_text != 'Mandatory')) &&
          ((this.selectedTask && this.selectedTask.add_response == 'Mandatory' && ((this.selectedAnswer && this.selectedAnswer.title) || (this.selectedDate && this.selectedDate != ''))) ||
          (this.selectedTask && this.selectedTask.add_response != 'Mandatory'))
        ) {

          if (this.selectedTask.response_type != 'Datepicker') {
            responseAnswer = this.selectedAnswer && this.selectedAnswer.title ? this.selectedAnswer.title : undefined
          } else {
            responseAnswer = this.selectedDate ? moment(this.selectedDate).format('YYYY-MM-DD') : undefined
          }

          piincHttp.put('tasks/' + this.selectedTask.id, {
            remarks: this.taskForm.remarks,
            control_description: this.taskForm.control_description,
            notes: this.taskForm.notes,
            performed_text: this.taskForm.performed_text,
            response: responseAnswer,
            status: 'completed',
            data_status: 'completed'
          }).then(function(response) {
            self.buttonDisabled = false;
            if (self.taskList.length > 1) {
              let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
              if (index < self.taskList.length - 1) {
                self.selectedTask = self.taskList[index + 1]
              } else {
                self.selectedTask = self.taskList[0]
              }
              self.taskList.splice(index, 1);
              self.loadTaskById(self.selectedTask.id);
            } else {
              var element = document.getElementsByClassName('task-modal');
              element[0].classList.add("hide-task-modal");
              self.$refs['all-done'].show()
            }
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = '';
          self.buttonDisabled = false;
          if (this.selectedTask.add_control_description == 'Mandatory' && !this.taskForm.control_description) {
            this.error += ' ' + this.$t('tasks.modal.control_description_error_message')
          }
          if (this.selectedTask.add_notes == 'Mandatory' && !this.taskForm.notes) {
            this.error += ' ' + this.$t('tasks.modal.notes_error_message')
          }
          if (this.selectedTask.add_performed_text == 'Mandatory' && !this.taskForm.performed_text) {
            this.error += ' ' + this.$t('tasks.modal.performed_test_error_message')
          }
          if (this.selectedTask.add_response == 'Mandatory' && (!this.selectedAnswer || (this.selectedAnswer && !this.selectedAnswer.title))) {
            this.error += ' ' + this.$t('tasks.modal.response_error_message')
          }
          if (this.selectedTask.add_description == 'Mandatory' && !this.taskForm.remarks) {
            this.error += ' ' + this.$t('tasks.modal.conclusion_error_message')
          }
          if ((this.selectedTask.add_attachments == 'Mandatory' && this.selectedTask.media && !this.selectedTask.media.length) && (this.selectedTask.add_attachments == 'Mandatory' && this.selectedTask.links && !this.selectedTask.links.length)) {
            this.error += ' ' + this.$t('tasks.modal.attachments_error_message')
          }

        }
      },
      saveDataTask() {
        var moment = require('moment');
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;

        if (
          ((this.selectedTask && this.selectedTask.data_collection_add_attachments == 'Mandatory' && ((this.getMedia('data_documents') && this.getMedia('data_documents').length) || (this.getLinks('data_documents') && this.getLinks('data_documents').length))) ||
            (this.selectedTask && this.selectedTask.data_collection_add_attachments != 'Mandatory')) &&
          ((this.selectedTask && this.selectedTask.data_collection_add_description == 'Mandatory' && this.taskForm.data_remarks) ||
            (this.selectedTask && this.selectedTask.data_collection_add_description != 'Mandatory'))
        ) {
          piincHttp.put('tasks/' + this.selectedTask.id, {
            data_remarks: this.taskForm.data_remarks
          }).then(function (response) {
            self.buttonDisabled = false;
            if (self.taskList.length > 1) {
              let index = _.findIndex(self.taskList, function (o) {
                return o.id == self.selectedTask.id
              });
              if (index < self.taskList.length - 1) {
                self.selectedTask = self.taskList[index + 1];
              } else {
                self.selectedTask = self.taskList[0];
              }
              self.taskList.splice(index, 1);
              self.loadTaskById(self.selectedTask.id);
            } else {
              self.$store.commit('storeTaskToolbarState', false);
              if (self.isOwner(self.selectedTask)) {
                self.currentView = 'default';
                self.loadTaskById(self.selectedTask.id);
              } else {
                self.hideTaskModal();
              }
            }
          }, function (error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = '';
          self.buttonDisabled = false;
          if (this.selectedTask.data_collection_add_description == 'Mandatory' && !this.taskForm.data_remarks) {
            this.error += ' ' + this.$t('tasks.modal.comment_error_message');
          }
          if ((this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getMedia('data_documents') && !this.getMedia('data_documents').length) && (this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getLinks('data_documents') && !this.getLinks('data_documents').length)) {
            this.error += ' ' + this.$t('tasks.modal.attachments_error_message');
          }

        }
      },
      completeDataTask() {
        var moment = require('moment');
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;

        if (
          ((this.selectedTask && this.selectedTask.data_collection_add_attachments == 'Mandatory' && ((this.getMedia('data_documents') && this.getMedia('data_documents').length) || (this.getLinks('data_documents') && this.getLinks('data_documents').length))) ||
          (this.selectedTask && this.selectedTask.data_collection_add_attachments != 'Mandatory')) &&
          ((this.selectedTask && this.selectedTask.data_collection_add_description == 'Mandatory' && this.taskForm.data_remarks) ||
          (this.selectedTask && this.selectedTask.data_collection_add_description != 'Mandatory'))
        ) {
          piincHttp.put('tasks/' + this.selectedTask.id, {
            data_remarks: this.taskForm.data_remarks,
            data_status: 'completed'
          }).then(function(response) {
            self.buttonDisabled = false;

            if (self.isOwner(self.selectedTask)) {
              self.switchCurrentView('default')
              self.loadTaskById(self.selectedTask.id);
            } else {
              if (self.taskList.length > 1) {
                let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
                if (index < self.taskList.length - 1) {
                  self.selectedTask = self.taskList[index + 1]
                } else {
                  self.selectedTask = self.taskList[0]
                }
                self.taskList.splice(index, 1);
                self.loadTaskById(self.selectedTask.id);
              } else {
                self.$store.commit('storeTaskToolbarState', false);
                self.hideTaskModal()
              }
            }
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = '';
          self.buttonDisabled = false;
          if (this.selectedTask.data_collection_add_description == 'Mandatory' && !this.taskForm.data_remarks) {
            this.error += ' ' + this.$t('tasks.modal.comment_error_message')
          }
          if ((this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getMedia('data_documents') && !this.getMedia('data_documents').length) && (this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getLinks('data_documents') && !this.getLinks('data_documents').length)) {
            this.error += ' ' + this.$t('tasks.modal.attachments_error_message')
          }

        }
      },
      completeSystemRiskTask() {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        if (
          this.taskForm.remarks != '' &&
          this.selectedConfidentialityImpact && this.selectedConfidentialityImpact.value &&
          this.selectedIntegrityImpact && this.selectedIntegrityImpact.value &&
          this.selectedAvailabilityImpact && this.selectedAvailabilityImpact.value &&
          this.taskForm.rto != '' &&
          this.taskForm.rpo != '' &&
          this.rtoInterval && this.rtoInterval.value &&
          this.rpoInterval && this.rpoInterval.value
        ) {
          piincHttp.put('tasks/' + this.selectedTask.id, {
            remarks: this.taskForm.remarks,
            confidentiality: this.selectedConfidentialityImpact ? this.selectedConfidentialityImpact.value : '',
            integrity: this.selectedIntegrityImpact ? this.selectedIntegrityImpact.value : '',
            availability: this.selectedAvailabilityImpact ? this.selectedAvailabilityImpact.value : '',
            rto_number: this.taskForm.rto,
            rto_type: this.rtoInterval ? this.rtoInterval.value : '',
            rpo_number: this.taskForm.rpo,
            rpo_type: this.rtoInterval ? this.rpoInterval.value : '',
            status: 'completed'
          }).then(function(response) {
            self.$toastr('success', self.$t('tasks.modal.success'))
            self.buttonDisabled = false;

            if (self.taskList.length > 1) {
              let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
              if (index < self.taskList.length - 1) {
                self.selectedTask = self.taskList[index + 1]
              } else {
                self.selectedTask = self.taskList[0]
              }
              self.taskList.splice(index, 1);
              self.loadTaskById(self.selectedTask.id);
            } else {
              var element = document.getElementsByClassName('task-modal');
              element[0].classList.add("hide-task-modal");
              self.$refs['all-done'].show()
            }
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = '';
          self.buttonDisabled = false;
          this.error = this.$t('tasks.modal.all_fields_error_message')
        }

      },
      saveTask() {
        var moment = require('moment');
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        let responseAnswer = '';

        if (this.selectedTask.response_type != 'Datepicker') {
          responseAnswer = this.selectedAnswer && this.selectedAnswer.title ? this.selectedAnswer.title : ''
        } else {
          responseAnswer = this.selectedDate ? moment(this.selectedDate).format('YYYY-MM-DD') : ''
        }

        piincHttp.put('tasks/' + this.selectedTask.id, {
          data_remarks: this.taskForm.data_remarks,
          remarks: this.taskForm.remarks,
          performed_text: this.taskForm.performed_text,
          control_description: this.taskForm.control_description,
          notes: this.taskForm.notes,
          confidentiality: this.selectedConfidentialityImpact ? this.selectedConfidentialityImpact.value : '',
          integrity: this.selectedIntegrityImpact ? this.selectedIntegrityImpact.value : '',
          availability: this.selectedAvailabilityImpact ? this.selectedAvailabilityImpact.value : '',
          rto_number: this.taskForm.rto,
          rto_type: this.rtoInterval ? this.rtoInterval.value : '',
          rpo_number: this.taskForm.rpo,
          rpo_type: this.rtoInterval ? this.rpoInterval.value : '',
          response: responseAnswer,
          data_response: this.selectedDataCollectionAnswer && this.selectedDataCollectionAnswer.length ? this.selectedDataCollectionAnswer : '',
        }).then(function(response) {
          self.buttonDisabled = false;
          self.$emit('reloadContent', response.data);
          self.hideTaskModal()
          self.$toastr('success', self.$t('tasks.modal.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })

      },
      previousTask() {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        piincHttp.put('tasks/' + this.selectedTask.id, {
          remarks: this.taskForm.remarks,
          performed_text: this.taskForm.performed_text,
          control_description: this.taskForm.control_description,
          confidentiality: this.selectedConfidentialityImpact ? this.selectedConfidentialityImpact.value : '',
          integrity: this.selectedIntegrityImpact ? this.selectedIntegrityImpact.value : '',
          availability: this.selectedAvailabilityImpact ? this.selectedAvailabilityImpact.value : '',
          rto_number: this.taskForm.rto,
          rto_type: this.rtoInterval ? this.rtoInterval.value : '',
          rpo_number: this.taskForm.rpo,
          rpo_type: this.rtoInterval ? this.rpoInterval.value : '',
          response: this.selectedAnswer && this.selectedAnswer.length ? this.selectedAnswer : undefined
        }).then(function(response) {
          self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })

        let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
        if (index > 0) {
          this.selectedTask = this.taskList[index - 1]
        } else {
          this.selectedTask = this.taskList[this.taskList.length - 1]
        }

        self.loadTaskById(this.selectedTask.id);

      },
      nextTask() {
        var moment = require('moment');
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        let responseAnswer = '';

        if (this.selectedTask.response_type != 'Datepicker') {
          responseAnswer = this.selectedAnswer && this.selectedAnswer.title ? this.selectedAnswer.title : undefined
        } else {
          responseAnswer = this.selectedDate ? moment(this.selectedDate).format('YYYY-MM-DD') : undefined
        }
        this.error = ''

        piincHttp.put('tasks/' + this.selectedTask.id, {
          data_remarks: this.taskForm.data_remarks,
          remarks: this.taskForm.remarks,
          notes: this.taskForm.notes,
          performed_text: this.taskForm.performed_text,
          control_description: this.taskForm.control_description,
          confidentiality: this.selectedConfidentialityImpact ? this.selectedConfidentialityImpact.value : '',
          integrity: this.selectedIntegrityImpact ? this.selectedIntegrityImpact.value : '',
          availability: this.selectedAvailabilityImpact ? this.selectedAvailabilityImpact.value : '',
          rto_number: this.taskForm.rto,
          rto_type: this.rtoInterval ? this.rtoInterval.value : '',
          rpo_number: this.taskForm.rpo,
          rpo_type: this.rtoInterval ? this.rpoInterval.value : '',
          response: responseAnswer,
          data_response: this.selectedDataCollectionAnswer && this.selectedDataCollectionAnswer.length ? this.selectedDataCollectionAnswer : '',
        }).then(function(response) {
          self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })

        let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
        if (index < this.taskList.length - 1) {
          this.selectedTask = this.taskList[index + 1]
        } else {
          this.selectedTask = this.taskList[0]
        }

        self.loadTaskById(self.selectedTask.id);

      },

      openDeleteAttachmentModal(object) {
        this.selectedFile = object
        this.showDeleteAttachmentModal = true
      },
      closeDeleteAttachmentModal () {
        this.selectedFile = {}
        this.showDeleteAttachmentModal = false;
        this.loadTaskById(this.selectedTask.id, true);
      },
      openDeleteLinkModal(object) {
        this.selectedLink = object
        this.showDeleteLinkModal = true
      },
      closeDeleteLinkModal () {
        this.selectedLink = {}
        this.showDeleteLinkModal = false;
        this.loadTaskById(this.selectedTask.id, true);
      },
      openDeleteCommentModal(object) {
        this.selectedComment = object
        this.showDeleteCommentModal = true
      },
      closeDeleteCommentModal () {
        this.selectedComment = {}
        this.showDeleteCommentModal = false;
        this.loadComments();
      },
      loadTaskGuide() {
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';
        let self = this;
        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Task',
            scope: 'assessment_task',
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.welcomeGuide = response.data.items[0]
            if (self.fromHomepage && !self.getUser.hide_assessment_task_guide) {
              self.showViewGuideModal(self.welcomeGuide)
            }
          }
        }, function() {});
      },
      handleLink() {
        let self = this;
        let formData = new FormData();

        if (!this.inputLink.startsWith('http')) {
          this.inputLink = 'http://' + this.inputLink
        }

        formData.append("url", this.inputLink);
        formData.append("name", this.inputLinkName);
        formData.append("collection", "task");
        formData.append("model_type", this.selectedTask.who_am_i);
        formData.append("model_id", this.selectedTask.id);

        piincHttp.post('links', formData).then(function() {
          self.inputLink = ''
          self.inputLinkName = ''
          self.hideCreateLinkModal()
          self.loadTaskById(self.selectedTask.id, true);
          self.showInput = false
        }, function() {})
      },
      handleDataCollectionLink() {
        let self = this;
        let formData = new FormData();

        if (!this.inputLink.startsWith('http')) {
          this.inputLink = 'http://' + this.inputLink
        }

        formData.append("url", this.inputLink);
        formData.append("name", this.inputLinkName);
        formData.append("collection", "data_documents");
        formData.append("model_type", this.selectedTask.who_am_i);
        formData.append("model_id", this.selectedTask.id);

        piincHttp.post('links', formData).then(function() {
          self.inputLink = ''
          self.inputLinkName = ''
          self.loadTaskById(self.selectedTask.id, true);
          self.showDataCollectionLinksSection = false
        }, function() {})
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {
          responseType: 'blob',
          params: {
            task: this.selectedTask.id
          }
        }).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      loadTaskById(id, ignorePopulate, data_remarks = '') {
        let self = this;
        piincHttp.get('tasks/' + id).then(function(response) {
          self.selectedTask = response.data;
          self.project_progress = self.selectedTask.project.user_progress.progress;
          self.populateForm(data_remarks)
	  self.loadLinkedControls();
          if (!ignorePopulate) {
            self.populateForm(data_remarks)

            // Checking the type of the users so the right view is displayed
            if (self.isOwner(self.selectedTask)) {
              self.switchCurrentView('default')
              if (self.selectedTask.code == 'update_measures') {
                self.loadGuidesSystem('system_description_task')
              } else {
                self.loadGuides('assessment_task')
              }
            } else {
              if (self.isDataOwner(self.selectedTask)) {
                self.switchCurrentView('data_collection')
              }
            }
          }

        }, function() {});
      },
      onFileChangeEdit(file) {
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        // Append list of attachments to FormData
        for (var i = 0; i < this.files.length; i++) {
          // Equal to 10 MB
          if (this.files[i].size > 31457280) {
            sizeError = true;
          }
          formData.append("document[]", this.files[i].file);
        }

        formData.append("name", "documents");
        formData.append("model_type", this.selectedTask.who_am_i);
        formData.append("model_id", this.selectedTask.id);

        if (sizeError) {
          this.sizeError = this.$t('system.file_size_30')
          this.files = []
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function() {
            self.error = ''
            self.sizeError = ''
            self.loadTaskById(self.selectedTask.id, true);
            self.files = []
          }, function(error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0]
            }
          })
        }
      },
      onDataFileChange(file) {
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        // Append list of attachments to FormData
        for (var i = 0; i < this.data_collection_files.length; i++) {
          // Equal to 10 MB
          if (this.data_collection_files[i].size > 31457280) {
            sizeError = true;
          }
          formData.append("document[]", this.data_collection_files[i].file);
        }

        formData.append("name", "documents");
        formData.append("collection", "data_documents");
        formData.append("model_type", this.selectedTask.who_am_i);
        formData.append("model_id", this.selectedTask.id);

        let data_remarks = this.taskForm.data_remarks
        if (sizeError) {
          this.error = this.$t('system.file_size_30')
          this.data_collection_files = []
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function() {
            self.error = ''
            self.loadTaskById(self.selectedTask.id, true, data_remarks);

            self.taskForm.data_remarks = data_remarks;

            self.data_collection_files = []
          }, function(error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0]
            }
          })
        }
      },
      onDragOver(event) {
        // Optional: You can handle visual cues when dragging over the area.
        console.log("Drag over");
      },
      processFiles(fileList) {
        // Process the list of files
        for (let i = 0; i < fileList.length; i++) {
          this.files.push(fileList[i]);
        }

        let self = this;
        let formData = new FormData();
        let sizeError = false;

        // Append list of attachments to FormData
        for (var i = 0; i < this.files.length; i++) {
          // Equal to 10 MB
          if (this.files[i].size > 31457280) {
            sizeError = true;
          }
          formData.append("document[]", this.files[i]);
        }

        formData.append("name", "documents");
        formData.append("model_type", this.selectedTask.who_am_i);
        formData.append("model_id", this.selectedTask.id);

        if (sizeError) {
          this.sizeError = this.$t('system.file_size_30');
          this.files = [];
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function () {
            self.error = '';
            self.sizeError = '';
            self.loadTaskById(self.selectedTask.id, true);
            self.files = [];
          }, function (error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0];
            }
          })
        }

        console.log("Dropped files:", this.files);
      },

      processFilesDocumentation(fileList) {
        // Process the list of files
        for (let i = 0; i < fileList.length; i++) {
          this.data_collection_files.push(fileList[i]);
        }

        let self = this;
        let formData = new FormData();
        let sizeError = false;

        // Append list of attachments to FormData
        for (var i = 0; i < this.data_collection_files.length; i++) {
          // Equal to 10 MB
          if (this.data_collection_files[i].size > 31457280) {
            sizeError = true;
          }
          formData.append("document[]", this.data_collection_files[i]);
        }

        formData.append("name", "documents");
        formData.append("collection", "data_documents");
        formData.append("model_type", this.selectedTask.who_am_i);
        formData.append("model_id", this.selectedTask.id);

        if (sizeError) {
          this.error = this.$t('system.file_size_30')
          this.data_collection_files = [];
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function () {
            self.error = '';
            self.loadTaskById(self.selectedTask.id, true);
            self.data_collection_files = [];
          }, function (error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0];
            }
          })
        }

        console.log("Dropped files:", this.files);
      },
      onFileDrop(event) {
        // Handle the file drop, prevent default to stop the default behavior
        console.log("File dropped");
      },
      handleDrop(event) {
        event.preventDefault(); // Prevent the default file-open behavior
        const files = event.dataTransfer.files; // Get the dropped files
        if (files.length) {
          this.processFiles(files); // Call a custom method to handle the files
        }
      },
      handleDropDocumentation(event) {
        event.preventDefault(); // Prevent the default file-open behavior
        const data_collection_files = event.dataTransfer.files; // Get the dropped files
        if (data_collection_files.length) {
          this.processFilesDocumentation(data_collection_files); // Call a custom method to handle the files
        }
      },
      hideDropActiveFunction() {
        // Handle when drop area becomes inactive
        console.log("Drop inactive");
      },
    },
    created () {

    }
  }
</script>
